/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */

import { Team, Confederation, ConfMeta, Sticker } from './types';

// flag helper: two ISO letters -> lowercase string
const f = (a: string, b: string) => (a + b).toLowerCase();

export const TEAMS: Team[] = [
    // HOSTS
    { id: "CAN", conf: "HOST", name: "Canada", flag: f("C", "A"), c1: "#D80621", c2: "#FFFFFF",
        players: [
            // Manager
            { n: "Jesse Marsch", pos: "HC", rare: "rare" },

            // Goalkeepers
            { n: "Dayne St. Clair (Inter Miami)", pos: "GK", rare: "rare" },
            { n: "Maxime Crépeau (Orlando City)", pos: "GK" },
            { n: "Owen Goodman (Barnsley)", pos: "GK" },

            // Defenders
            { n: "Moïse Bombito (Nice)", pos: "DF", rare: "rare" },
            { n: "Derek Cornelius (Rangers)", pos: "DF" },
            { n: "Alphonso Davies (Bayern Munich)", pos: "DF", rare: "legendary" },
            { n: "Luc De Fougerolles (FCV Dender)", pos: "DF" },
            { n: "Alistair Johnston (Celtic)", pos: "DF", rare: "rare" },
            { n: "Alfie Jones (Middlesbrough)", pos: "DF" },
            { n: "Richie Laryea (Toronto FC)", pos: "DF" },
            { n: "Niko Sigur (Hajduk Split)", pos: "DF" },
            { n: "Joel Waterman (Chicago Fire)", pos: "DF" },

            // Midfielders
            { n: "Ali Ahmed (Norwich City)", pos: "MF" },
            { n: "Tajon Buchanan (Villarreal)", pos: "MF", rare: "rare" },
            { n: "Mathieu Choinière (LAFC)", pos: "MF" },
            { n: "Stephen Eustáquio (LAFC)", pos: "MF", rare: "rare" },
            { n: "Marcelo Flores (Tigres UANL)", pos: "MF" },
            { n: "Ismaël Koné (Sassuolo)", pos: "MF", rare: "rare" },
            { n: "Liam Millar (Hull City)", pos: "MF" },
            { n: "Jonathan Osorio (Toronto FC)", pos: "MF" },
            { n: "Nathan Saliba (Anderlecht)", pos: "MF" },
            { n: "Jacob Shaffelburg (LAFC)", pos: "MF", rare: "rare" },

            // Forwards
            { n: "Jonathan David (Juventus)", pos: "FW", rare: "legendary" },
            { n: "Promise David (Royale-Union Saint Gilloise)", pos: "FW" },
            { n: "Cyle Larin (Southampton)", pos: "FW", rare: "rare" },
            { n: "Tani Oluwaseyi (Villarreal)", pos: "FW" }
        ] },
    { id: "MEX", conf: "HOST", name: "Mexico", flag: f("M", "X"), c1: "#006847", c2: "#CE1126",
        players: [
            // Goalkeepers
            { n: "Álex Padilla (Athletic Club)", pos: "GK" },
            { n: "Antonio Rodríguez (Tijuana)", pos: "GK" },
            { n: "Carlos Acevedo (Santos Laguna)", pos: "GK", rare: "rare" },
            { n: "Carlos Moreno (Pachuca)", pos: "GK" },
            { n: "Guillermo Ochoa (AEL Limassol)", pos: "GK", rare: "rare" },
            { n: "Raúl Rangel (Chivas)", pos: "GK" },

            // Defenders
            { n: "Bryan González (Chivas)", pos: "DF" },
            { n: "César Montes (Lokomotiv Moscow)", pos: "DF", rare: "rare" },
            { n: "Edson Álvarez (Fenerbahçe)", pos: "DF", rare: "rare" },
            { n: "Eduardo Águila (Atlético de San Luis)", pos: "DF" },
            { n: "Everardo López (Toluca)", pos: "DF" },
            { n: "Israel Reyes (América)", pos: "DF" },
            { n: "Jesús Angulo (Tigres)", pos: "DF" },
            { n: "Jesús Gallardo (Toluca)", pos: "DF" },
            { n: "Jesús Gómez (Tijuana)", pos: "DF" },
            { n: "Johan Vásquez (Genoa)", pos: "DF", rare: "rare" },
            { n: "Jorge Sánchez (PAOK)", pos: "DF" },
            { n: "Julián Araujo (Celtic)", pos: "DF", rare: "rare" },
            { n: "Luis Rey (Puebla)", pos: "DF" },
            { n: "Mateo Chávez (AZ Alkmaar)", pos: "DF" },
            { n: "Ramón Juárez (América)", pos: "DF" },
            { n: "Richard Ledezma (Chivas)", pos: "DF" },
            { n: "Víctor Guzmán (Monterrey)", pos: "DF" },

            // Midfielders
            { n: "Alexei Domínguez (Pachuca)", pos: "MF" },
            { n: "Alexis Gutiérrez (America)", pos: "MF" },
            { n: "Álvaro Fidalgo (Real Betis)", pos: "MF", rare: "rare" },
            { n: "Brian Gutiérrez (Chivas)", pos: "MF" },
            { n: "Carlos Rodríguez (Cruz Azul)", pos: "MF" },
            { n: "Denzell Garcia (FC Juarez)", pos: "MF" },
            { n: "Diego Lainez (Tigres)", pos: "MF" },
            { n: "Efrain Álvarez (Chivas)", pos: "MF" },
            { n: "Elias Montiel (Pachuca)", pos: "MF" },
            { n: "Erick Sánchez (America)", pos: "MF", rare: "rare" },
            { n: "Erik Lira (Cruz Azul)", pos: "MF" },
            { n: "Gilberto Mora (Tijuana)", pos: "MF" },
            { n: "Isaías Violante (America)", pos: "MF" },
            { n: "Jeremy Márquez (Cruz Azul)", pos: "MF" },
            { n: "Jordan Carrillo (Pumas)", pos: "MF" },
            { n: "Jorge Ruvalcaba (NY Red Bulls)", pos: "MF" },
            { n: "Kevin Castañeda (Tijuana)", pos: "MF" },
            { n: "Luis Chávez (Dinamo Moscu)", pos: "MF", rare: "rare" },
            { n: "Luis Romo (Chivas)", pos: "MF" },
            { n: "Marcel Ruiz (Toluca)", pos: "MF", rare: "rare" },
            { n: "Obed Vargas (Atlético de Madrid)", pos: "MF", rare: "rare" },
            { n: "Orbelín Pineda (AEK)", pos: "MF", rare: "rare" },
            { n: "Jesús Angulo (Toluca)", pos: "MF" },

            // Forwards
            { n: "Alexis Vega (Toluca)", pos: "FW", rare: "rare" },
            { n: "Armando González (Chivas)", pos: "FW" },
            { n: "César Huerta (Anderlecht)", pos: "FW" },
            { n: "Germán Berterame (Inter Miami)", pos: "FW" },
            { n: "Guillermo Martínez (Pumas)", pos: "FW" },
            { n: "Julián Quiñones (Al-Qadisiyah)", pos: "FW", rare: "rare" },
            { n: "Raúl Jiménez (Fulham)", pos: "FW", rare: "rare" },
            { n: "Roberto Alvarado (Chivas)", pos: "FW", rare: "rare" },
            { n: "Santiago Giménez (Milan)", pos: "FW", rare: "legendary" }
        ] },
    { id: "USA", conf: "HOST", name: "United States", flag: f("U", "S"), c1: "#0A2A5E", c2: "#B31942",
        players: [
            // Manager
            { n: "Mauricio Pochettino", pos: "HC", rare: "rare" },

            // Goalkeepers
            { n: "Chris Brady (Chicago Fire)", pos: "GK" },
            { n: "Matt Freese (New York City FC)", pos: "GK" },
            { n: "Matt Turner (New England Revolution)", pos: "GK", rare: "rare" },

            // Defenders
            { n: "Max Arfsten (Columbus Crew)", pos: "DF" },
            { n: "Sergiño Dest (PSV Eindhoven)", pos: "DF", rare: "rare" },
            { n: "Alex Freeman (Villarreal)", pos: "DF" },
            { n: "Mark McKenzie (Toulouse)", pos: "DF" },
            { n: "Tim Ream (Charlotte FC)", pos: "DF" },
            { n: "Chris Richards (Crystal Palace)", pos: "DF" },
            { n: "Antonee Robinson (Fulham)", pos: "DF", rare: "rare" },
            { n: "Miles Robinson (FC Cincinnati)", pos: "DF" },
            { n: "Joe Scally (Borussia Mönchengladbach)", pos: "DF" },
            { n: "Auston Trusty (Celtic)", pos: "DF" },

            // Midfielders
            { n: "Tyler Adams (AFC Bournemouth)", pos: "MF", rare: "rare" },
            { n: "Sebastian Berhalter (Vancouver Whitecaps)", pos: "MF" },
            { n: "Weston McKennie (Juventus)", pos: "MF", rare: "rare" },
            { n: "Cristian Roldan (Seattle Sounders)", pos: "MF" },
            { n: "Brenden Aaronson (Leeds United)", pos: "MF" },
            { n: "Malik Tillman (Bayer Leverkusen)", pos: "MF", rare: "rare" },
            { n: "Tim Weah (Marseille)", pos: "MF", rare: "rare" },
            { n: "Alejandro Zendejas (Club América)", pos: "MF" },

            // Forwards
            { n: "Christian Pulisic (AC Milan)", pos: "FW", rare: "legendary" },
            { n: "Gio Reyna (Borussia Mönchengladbach)", pos: "FW", rare: "rare" },
            { n: "Folarin Balogun (AS Monaco)", pos: "FW", rare: "rare" },
            { n: "Ricardo Pepi (PSV Eindhoven)", pos: "FW", rare: "rare" },
            { n: "Haji Wright (Coventry City)", pos: "FW" }
        ] },

    // UEFA
    { id: "BEL", conf: "UEFA", name: "Belgium", flag: f("B", "E"), c1: "#EF3340", c2: "#000000",
        players: [
            // Manager
            { n: "Rudi Garcia", pos: "HC", rare: "rare" },

            // Goalkeepers
            { n: "Thibaut Courtois (Real Madrid)", pos: "GK", rare: "legendary" },
            { n: "Senne Lammens (Manchester United)", pos: "GK" },
            { n: "Mike Penders (Chelsea)", pos: "GK" },

            // Defenders
            { n: "Timothy Castagne (Fulham)", pos: "DF" },
            { n: "Zeno Debast (Sporting CP)", pos: "DF" },
            { n: "Maxim De Cuyper (Brighton & Hove Albion)", pos: "DF", rare: "rare" },
            { n: "Koni De Winter (AC Milan)", pos: "DF" },
            { n: "Brandon Mechele (Club Brugge)", pos: "DF" },
            { n: "Thomas Meunier (Lille)", pos: "DF" },
            { n: "Nathan Ngoy (Lille)", pos: "DF" },
            { n: "Joaquin Seys (Club Brugge)", pos: "DF" },
            { n: "Arthur Theate (Eintracht Frankfurt)", pos: "DF", rare: "rare" },

            // Midfielders
            { n: "Kevin De Bruyne (Napoli)", pos: "MF", rare: "legendary" },
            { n: "Amadou Onana (Aston Villa)", pos: "MF", rare: "rare" },
            { n: "Nicolas Raskin (Rangers)", pos: "MF" },
            { n: "Youri Tielemans (Aston Villa)", pos: "MF", rare: "rare" },
            { n: "Hans Vanaken (Club Brugge)", pos: "MF" },
            { n: "Axel Witsel (Girona)", pos: "MF", rare: "rare" },

            // Forwards
            { n: "Charles De Ketelaere (Atalanta)", pos: "FW", rare: "rare" },
            { n: "Jérémy Doku (Manchester City)", pos: "FW", rare: "rare" },
            { n: "Matias Fernandez-Pardo (Lille)", pos: "FW" },
            { n: "Romelu Lukaku (Napoli)", pos: "FW", rare: "rare" },
            { n: "Dodi Lukebakio (Benfica)", pos: "FW" },
            { n: "Diego Moreira (Strasbourg)", pos: "FW" },
            { n: "Alexis Saelemaekers (AC Milan)", pos: "FW" },
            { n: "Leandro Trossard (Arsenal)", pos: "FW", rare: "rare" }
        ] },
    { id: "CRO", conf: "UEFA", name: "Croatia", flag: f("H", "R"), c1: "#CC0000", c2: "#FFFFFF",
        players: [
            // Manager
            { n: "Zlatko Dalic", pos: "HC", rare: "rare" },

            // Goalkeepers
            { n: "Dominik Livakovic (Dinamo Zagreb)", pos: "GK", rare: "rare" },
            { n: "Dominik Kotarski (Kobenhavn)", pos: "GK" },
            { n: "Ivor Pandur (Hull City)", pos: "GK" },

            // Defenders
            { n: "Josko Gvardiol (Manchester City)", pos: "DF", rare: "legendary" },
            { n: "Duje Caleta-Car (Real Sociedad)", pos: "DF" },
            { n: "Josip Sutalo (Ajax)", pos: "DF", rare: "rare" },
            { n: "Josip Stanisic (Bayern Munich)", pos: "DF", rare: "rare" },
            { n: "Marin Pongracic (Fiorentina)", pos: "DF" },
            { n: "Martin Erlic (Midtjylland)", pos: "DF" },
            { n: "Luka Vuskovic (Hamburg)", pos: "DF" },

            // Midfielders
            { n: "Luka Modric (AC Milan)", pos: "MF", rare: "legendary" },
            { n: "Mateo Kovacic (Manchester City)", pos: "MF", rare: "rare" },
            { n: "Mario Pasalic (Atalanta)", pos: "MF", rare: "rare" },
            { n: "Nikola Vlasic (Torino)", pos: "MF" },
            { n: "Luka Sucic (Real Sociedad)", pos: "MF", rare: "rare" },
            { n: "Martin Baturina (Como)", pos: "MF" },
            { n: "Kristijan Jakic (Augsburg)", pos: "MF" },
            { n: "Petar Sucic (Inter Milan)", pos: "MF" },
            { n: "Nikola Moro (Bologna)", pos: "MF" },
            { n: "Toni Fruk (Rijeka)", pos: "MF" },

            // Forwards
            { n: "Ivan Perisic (PSV Eindhoven)", pos: "FW", rare: "rare" },
            { n: "Andrej Kramaric (Hoffenheim)", pos: "FW", rare: "rare" },
            { n: "Ante Budimir (Osasuna)", pos: "FW" },
            { n: "Marco Pasalic (Orlando City)", pos: "FW" },
            { n: "Petar Musa (FC Dallas)", pos: "FW" },
            { n: "Igor Matanovic (Freiburg)", pos: "FW" }
        ] },
    { id: "ENG", conf: "UEFA", name: "England", flag: "gb-eng", c1: "#002B7F", c2: "#C8102E",
        players: [
            // Manager
            { n: "Thomas Tuchel", pos: "HC", rare: "rare" },

            // Goalkeepers
            { n: "Jordan Pickford (Everton)", pos: "GK", rare: "rare" },
            { n: "Dean Henderson (Crystal Palace)", pos: "GK" },
            { n: "James Trafford (Manchester City)", pos: "GK" },

            // Defenders
            { n: "Reece James (Chelsea)", pos: "DF" },
            { n: "Ezri Konsa (Aston Villa)", pos: "DF" },
            { n: "Jarell Quansah (Bayer Leverkusen)", pos: "DF" },
            { n: "John Stones (Manchester City)", pos: "DF", rare: "rare" },
            { n: "Marc Guéhi (Manchester City)", pos: "DF" },
            { n: "Dan Burn (Newcastle United)", pos: "DF" },
            { n: "Nico O'Reilly (Manchester City)", pos: "DF" },
            { n: "Djed Spence (Tottenham Hotspur)", pos: "DF" },
            { n: "Tino Livramento (Newcastle United)", pos: "DF" },

            // Midfielders
            { n: "Declan Rice (Arsenal)", pos: "MF", rare: "rare" },
            { n: "Elliot Anderson (Nottingham Forest)", pos: "MF" },
            { n: "Kobbie Mainoo (Manchester United)", pos: "MF", rare: "rare" },
            { n: "Jordan Henderson (Brentford)", pos: "MF" },
            { n: "Morgan Rogers (Aston Villa)", pos: "MF" },
            { n: "Jude Bellingham (Real Madrid)", pos: "MF", rare: "legendary" },
            { n: "Eberechi Eze (Arsenal)", pos: "MF" },

            // Forwards
            { n: "Harry Kane (Bayern Munich)", pos: "FW", rare: "legendary" },
            { n: "Ivan Toney (Al-Ahli)", pos: "FW" },
            { n: "Ollie Watkins (Aston Villa)", pos: "FW" },
            { n: "Bukayo Saka (Arsenal)", pos: "FW", rare: "rare" },
            { n: "Marcus Rashford (Manchester United)", pos: "FW" },
            { n: "Anthony Gordon (Newcastle United)", pos: "FW" },
            { n: "Noni Madueke (Arsenal)", pos: "FW" }
        ] },
    { id: "FRA", conf: "UEFA", name: "France", flag: f("F", "R"), c1: "#002395", c2: "#ED2939",
        players: [
            // Manager
            { n: "Didier Deschamps", pos: "HC", rare: "rare" },

            // Goalkeepers
            { n: "Mike Maignan (AC Milan)", pos: "GK", rare: "rare" },
            { n: "Robin Risser (Lens)", pos: "GK" },
            { n: "Brice Samba (Rennes)", pos: "GK" },

            // Defenders
            { n: "Lucas Digne (Aston Villa)", pos: "DF" },
            { n: "Malo Gusto (Chelsea)", pos: "DF" },
            { n: "Lucas Hernández (Paris Saint-Germain)", pos: "DF" },
            { n: "Theo Hernández (Al Hilal)", pos: "DF", rare: "rare" },
            { n: "Ibrahima Konaté (Liverpool)", pos: "DF" },
            { n: "Jules Koundé (Barcelona)", pos: "DF", rare: "rare" },
            { n: "Maxence Lacroix (Crystal Palace)", pos: "DF" },
            { n: "William Saliba (Arsenal)", pos: "DF", rare: "rare" },
            { n: "Dayot Upamecano (Bayern Munich)", pos: "DF", rare: "rare" },

            // Midfielders
            { n: "N'Golo Kanté (Fenerbahçe)", pos: "MF", rare: "rare" },
            { n: "Manu Koné (AS Roma)", pos: "MF" },
            { n: "Adrien Rabiot (AC Milan)", pos: "MF" },
            { n: "Aurélien Tchouaméni (Real Madrid)", pos: "MF", rare: "rare" },
            { n: "Warren Zaïre-Emery (Paris Saint-Germain)", pos: "MF", rare: "rare" },

            // Forwards
            { n: "Maghnes Akliouche (AS Monaco)", pos: "FW" },
            { n: "Bradley Barcola (Paris Saint-Germain)", pos: "FW", rare: "rare" },
            { n: "Rayan Cherki (Manchester City)", pos: "FW", rare: "rare" },
            { n: "Ousmane Dembélé (Paris Saint-Germain)", pos: "FW", rare: "rare" },
            { n: "Désiré Doué (Paris Saint-Germain)", pos: "FW" },
            { n: "Jean-Philippe Mateta (Crystal Palace)", pos: "FW" },
            { n: "Kylian Mbappé (Real Madrid)", pos: "FW", rare: "legendary" },
            { n: "Michael Olise (Bayern Munich)", pos: "FW", rare: "rare" },
            { n: "Marcus Thuram (Internazionale)", pos: "FW" }
        ] },
    { id: "GER", conf: "UEFA", name: "Germany", flag: f("D", "E"), c1: "#2a2a2a", c2: "#DD0000",
        players: [
            // Manager
            { n: "Julian Nagelsmann", pos: "HC", rare: "rare" },

            // Goalkeepers
            { n: "Oliver Baumann (Hoffenheim)", pos: "GK" },
            { n: "Manuel Neuer (Bayern Munich)", pos: "GK", rare: "rare" },
            { n: "Alexander Nübel (Stuttgart)", pos: "GK" },

            // Defenders
            { n: "Waldemar Anton (Borussia Dortmund)", pos: "DF" },
            { n: "Nathaniel Brown (Eintracht Frankfurt)", pos: "DF" },
            { n: "David Raum (RB Leipzig)", pos: "DF" },
            { n: "Antonio Rüdiger (Real Madrid)", pos: "DF", rare: "rare" },
            { n: "Nico Schlotterbeck (Borussia Dortmund)", pos: "DF" },
            { n: "Jonathan Tah (Bayern Munich)", pos: "DF", rare: "rare" },
            { n: "Malick Thiaw (Newcastle)", pos: "DF" },

            // Midfielders
            { n: "Pascal Gross (Brighton)", pos: "MF" },
            { n: "Joshua Kimmich (Bayern Munich)", pos: "MF", rare: "rare" },
            { n: "Felix Nmecha (Borussia Dortmund)", pos: "MF" },
            { n: "Aleksandar Pavlovic (Bayern Munich)", pos: "MF" },
            { n: "Angelo Stiller (Stuttgart)", pos: "MF" },
            { n: "Leon Goretzka (Bayern Munich)", pos: "MF" },
            { n: "Florian Wirtz (Liverpool)", pos: "MF", rare: "legendary" },
            { n: "Jamie Leweling (Stuttgart)", pos: "MF" },

            // Forwards
            { n: "Maximilian Beier (Borussia Dortmund)", pos: "FW" },
            { n: "Kai Havertz (Arsenal)", pos: "FW", rare: "rare" },
            { n: "Lennart Karl (Bayern Munich)", pos: "FW" },
            { n: "Jamal Musiala (Bayern Munich)", pos: "FW", rare: "rare" },
            { n: "Leroy Sané (Galatasaray)", pos: "FW", rare: "rare" },
            { n: "Deniz Undav (Stuttgart)", pos: "FW" },
            { n: "Nick Woltemade (Newcastle)", pos: "FW" }
        ] },
    { id: "NED", conf: "UEFA", name: "Netherlands", flag: f("N", "L"), c1: "#C8501A", c2: "#FFFFFF",
        players: [
            // Manager
            { n: "Ronald Koeman", pos: "HC", rare: "rare" },

            // Goalkeepers
            { n: "Mark Flekken (Bayer Leverkusen)", pos: "GK" },
            { n: "Robin Roefs (Sunderland)", pos: "GK" },
            { n: "Bart Verbruggen (Brighton)", pos: "GK", rare: "rare" },

            // Defenders
            { n: "Nathan Aké (Manchester City)", pos: "DF", rare: "rare" },
            { n: "Denzel Dumfries (Inter Milan)", pos: "DF", rare: "rare" },
            { n: "Jorrel Hato (Chelsea)", pos: "DF" },
            { n: "Jurriën Timber (Arsenal)", pos: "DF" },
            { n: "Jan Paul van Hecke (Brighton)", pos: "DF" },
            { n: "Micky van de Ven (Tottenham)", pos: "DF", rare: "rare" },
            { n: "Virgil van Dijk (Liverpool)", pos: "DF", rare: "legendary" },

            // Midfielders
            { n: "Frenkie de Jong (Barcelona)", pos: "MF", rare: "rare" },
            { n: "Marten de Roon (Atalanta)", pos: "MF" },
            { n: "Ryan Gravenberch (Liverpool)", pos: "MF", rare: "rare" },
            { n: "Teun Koopmeiners (Juventus)", pos: "MF", rare: "rare" },
            { n: "Tijjani Reijnders (Manchester City)", pos: "MF", rare: "rare" },
            { n: "Guus Til (PSV)", pos: "MF" },
            { n: "Quinten Timber (Marseille)", pos: "MF" },
            { n: "Mats Wieffer (Brighton)", pos: "MF" },

            // Forwards
            { n: "Brian Brobbey (Sunderland)", pos: "FW" },
            { n: "Memphis Depay (Corinthians)", pos: "FW", rare: "rare" },
            { n: "Cody Gakpo (Liverpool)", pos: "FW", rare: "rare" },
            { n: "Justin Kluivert (Bournemouth)", pos: "FW" },
            { n: "Noa Lang (Galatasaray)", pos: "FW" },
            { n: "Donyell Malen (Roma)", pos: "FW", rare: "rare" },
            { n: "Crysencio Summerville (West Ham)", pos: "FW" },
            { n: "Wout Weghorst (Ajax)", pos: "FW" }
        ] },
    { id: "POR", conf: "UEFA", name: "Portugal", flag: f("P", "T"), c1: "#006600", c2: "#FF0000",
        players: [
            // Manager
            { n: "Roberto Martinez", pos: "HC", rare: "rare" },

            // Goalkeepers
            { n: "Diogo Costa (Porto)", pos: "GK", rare: "rare" },
            { n: "José Sá (Wolverhampton Wanderers)", pos: "GK" },
            { n: "Rui Silva (Sporting Lisbon)", pos: "GK" },
            { n: "Ricardo Velho (Gençlerbirliği)", pos: "GK" },

            // Defenders
            { n: "Rúben Dias (Manchester City)", pos: "DF", rare: "rare" },
            { n: "João Cancelo (Barcelona)", pos: "DF", rare: "rare" },
            { n: "Diogo Dalot (Manchester United)", pos: "DF", rare: "rare" },
            { n: "Nuno Mendes (Paris Saint-Germain)", pos: "DF", rare: "rare" },
            { n: "Nélson Semedo (Fenerbahce)", pos: "DF" },
            { n: "Matheus Nunes (Manchester City)", pos: "DF" },
            { n: "Gonçalo Inacio (Sporting Lisbon)", pos: "DF" },
            { n: "Renato Veiga (Villarreal)", pos: "DF" },
            { n: "Tomás Araújo (Benfica)", pos: "DF" },

            // Midfielders
            { n: "Bruno Fernandes (Manchester United)", pos: "MF", rare: "rare" },
            { n: "Bernardo Silva (Manchester City)", pos: "MF", rare: "rare" },
            { n: "Vitinha (PSG)", pos: "MF", rare: "rare" },
            { n: "João Neves (PSG)", pos: "MF" },
            { n: "Rúben Neves (Al Hilal)", pos: "MF" },
            { n: "Samú Costa (Mallorca)", pos: "MF" },

            // Forwards
            { n: "Cristiano Ronaldo (Al Nassr)", pos: "FW", rare: "legendary" },
            { n: "Rafael Leão (AC Milan)", pos: "FW", rare: "rare" },
            { n: "João Félix (Al Nassr)", pos: "FW", rare: "rare" },
            { n: "Gonçalo Ramos (PSG)", pos: "FW", rare: "rare" },
            { n: "Pedro Neto (Chelsea)", pos: "FW" },
            { n: "Francisco Conceição (Juventus)", pos: "FW" },
            { n: "Gonçalo Guedes (Real Sociedad)", pos: "FW" },
            { n: "Francisco Trincão (Sporting Lisbon)", pos: "FW" }
        ] },
    { id: "ESP", conf: "UEFA", name: "Spain", flag: f("E", "S"), c1: "#AA151B", c2: "#F1BF00",
        players: [
            // Manager
            { n: "Luis de la Fuente", pos: "HC", rare: "rare" },

            // Goalkeepers
            { n: "Unai Simón (Athletic Club)", pos: "GK", rare: "rare" },
            { n: "David Raya (Arsenal)", pos: "GK" },
            { n: "Joan García (Barcelona)", pos: "GK" },

            // Defenders
            { n: "Marc Cucurella (Chelsea)", pos: "DF" },
            { n: "Pau Cubarsí (Barcelona)", pos: "DF" },
            { n: "Aymeric Laporte (Athletic Club)", pos: "DF" },
            { n: "Álex Grimaldo (Bayer Leverkusen)", pos: "DF" },
            { n: "Pedro Porro (Tottenham Hotspur)", pos: "DF" },
            { n: "Eric García (Barcelona)", pos: "DF" },
            { n: "Marcos Llorente (Atlético Madrid)", pos: "DF" },
            { n: "Marc Pubill (Atlético Madrid)", pos: "DF" },

            // Midfielders
            { n: "Gavi (Barcelona)", pos: "MF", rare: "rare" },
            { n: "Rodri (Manchester City)", pos: "MF", rare: "rare" },
            { n: "Pedri (Barcelona)", pos: "MF", rare: "rare" },
            { n: "Martín Zubimendi (Arsenal)", pos: "MF" },
            { n: "Fabián Ruiz (PSG)", pos: "MF" },
            { n: "Álex Baena (Atlético Madrid)", pos: "MF" },
            { n: "Mikel Merino (Arsenal)", pos: "MF" },

            // Forwards
            { n: "Lamine Yamal (Barcelona)", pos: "FW", rare: "legendary" },
            { n: "Nico Williams (Athletic Club)", pos: "FW", rare: "rare" },
            { n: "Dani Olmo (Barcelona)", pos: "FW", rare: "rare" },
            { n: "Ferran Torres (Barcelona)", pos: "FW" },
            { n: "Mikel Oyarzabal (Real Sociedad)", pos: "FW" },
            { n: "Yéremy Pino (Crystal Palace)", pos: "FW" },
            { n: "Borja Iglesias (Celta Vigo)", pos: "FW" },
            { n: "Víctor Muñoz (Osasuna)", pos: "FW" }
        ] },
    { id: "ITA", conf: "UEFA", name: "Italy", flag: f("I", "T"), c1: "#0064AA", c2: "#FFFFFF",
        players: [{ n: "F. Chiesa", pos: "FW", rare: "rare" }, { n: "N. Barella", pos: "MF", rare: "rare" }, { n: "A. Bastoni", pos: "DF" }, { n: "G. Donnarumma", pos: "GK", rare: "rare" }] },
    { id: "AUT", conf: "UEFA", name: "Austria", flag: f("A", "T"), c1: "#ED2939", c2: "#FFFFFF",
        players: [
            // Manager
            { n: "Ralf Rangnick", pos: "HC", rare: "rare" },

            // Goalkeepers
            { n: "Alexander Schlager (RB Salzburg)", pos: "GK", rare: "rare" },
            { n: "Florian Wiegele (Viktoria Plzen)", pos: "GK" },
            { n: "Patrick Pentz (Brondby)", pos: "GK" },

            // Defenders
            { n: "David Affengruber (Elche)", pos: "DF" },
            { n: "Kevin Danso (Tottehham)", pos: "DF", rare: "rare" },
            { n: "Stefan Posch (Mainz 05)", pos: "DF" },
            { n: "David Alaba (Real Madrid)", pos: "DF", rare: "legendary" },
            { n: "Philipp Lienhart (SC Freiburg)", pos: "DF" },
            { n: "Philipp Mwene (Mainz 05)", pos: "DF" },
            { n: "Alexander Prass (TSG Hoffenheim)", pos: "DF" },
            { n: "Marco Friedl (Werder Bremen)", pos: "DF" },
            { n: "Michael Svoboda (Venezia)", pos: "DF" },

            // Midfielders
            { n: "Xaver Schlager (RB Leipzig)", pos: "MF" },
            { n: "Nicolas Seiwald (RB Leipzig)", pos: "MF" },
            { n: "Marcel Sabitzer (Borussia Dortmund)", pos: "MF", rare: "rare" },
            { n: "Florian Grillitsch (Braga)", pos: "MF" },
            { n: "Carney Chukwuemeka (Borussia Dortmund)", pos: "MF" },
            { n: "Romano Schmid (Werder Bremen)", pos: "MF" },
            { n: "Christoph Baumgartner (RB Leipzig)", pos: "MF", rare: "rare" },
            { n: "Konrad Laimer (Bayern Munich)", pos: "MF", rare: "rare" },
            { n: "Patrick Wimmer (Wolfsburg)", pos: "MF" },
            { n: "Paul Wanner (PSV Eindhoven)", pos: "MF" },
            { n: "Alessandro Schopf (Wolfsberger AC)", pos: "MF" },

            // Forwards
            { n: "Marko Arnautovic (Red Star Belgrade)", pos: "FW", rare: "rare" },
            { n: "Michael Gregoritsch (FC Augsburg)", pos: "FW" },
            { n: "Sasa Kalajdzic (LASK Linz)", pos: "FW" }
        ] },
    { id: "BIH", conf: "UEFA", name: "Bosnia and Herzegovina", flag: f("B", "A"), c1: "#002395", c2: "#FECB00",
        players: [
            // Goalkeepers
            { n: "Nikola Vasilj (St Pauli)", pos: "GK" },
            { n: "Martin Zlomislic (Rijeka)", pos: "GK" },
            { n: "Osman Hadzikic (Slaven Belupo)", pos: "GK" },

            // Defenders
            { n: "Sead Kolasinac (Atalanta)", pos: "DF", rare: "rare" },
            { n: "Amar Dedic (Benfica)", pos: "DF", rare: "rare" },
            { n: "Nihad Mujakic (Gaziantep)", pos: "DF" },
            { n: "Nikola Katic (Schalke 04)", pos: "DF" },
            { n: "Tarik Muharemovic (Sassuolo)", pos: "DF" },
            { n: "Stjepan Radeljic (Rijeka)", pos: "DF" },
            { n: "Dennis Hadzikadunic (Sampdoria)", pos: "DF" },
            { n: "Nidal Celik (Lens)", pos: "DF" },

            // Midfielders
            { n: "Amir Hadziahmetovic (Hull City)", pos: "MF" },
            { n: "Ivan Sunjic (Pafos)", pos: "MF" },
            { n: "Ivan Basic (Astana)", pos: "MF" },
            { n: "Dzenis Burnic (Karlsruher SC)", pos: "MF" },
            { n: "Ermin Mahmic (Slovan Liberec)", pos: "MF" },
            { n: "Benjamin Tahirovic (Brondby)", pos: "MF" },
            { n: "Amar Memic (Viktoria Plzen)", pos: "MF" },
            { n: "Armin Gigovic (Young Boys)", pos: "MF" },
            { n: "Kerim Alajbegovic (RB Salzburg)", pos: "MF" },
            { n: "Esmir Bajraktarevic (PSV Eindhoven)", pos: "MF", rare: "rare" },

            // Forwards
            { n: "Ermedin Demirovic (VfB Stuttgart)", pos: "FW", rare: "rare" },
            { n: "Jovo Lukic (Universitatea Cluj)", pos: "FW" },
            { n: "Samed Bazdar (Jagiellonia Bialystok)", pos: "FW" },
            { n: "Haris Tabakovic (Borussia Moenchengladbach)", pos: "FW" },
            { n: "Edin Dzeko (Schalke 04)", pos: "FW", rare: "legendary" }
        ] },
    { id: "CZE", conf: "UEFA", name: "Czechia", flag: f("C", "Z"), c1: "#11457E", c2: "#D7141A",
        players: [
            // Goalkeepers
            { n: "Lukas Hornicek (Braga)", pos: "GK" },
            { n: "Martin Jedlicka (Banik Ostrava)", pos: "GK" },
            { n: "Antonín Kinsky (Tottenham)", pos: "GK" },
            { n: "Jan Koutny (Sigma Olomouc)", pos: "GK" },
            { n: "Matej Kovar (PSV Eindhoven)", pos: "GK", rare: "rare" },
            { n: "Jakub Markovic (Slavia Prague)", pos: "GK" },
            { n: "Jindrich Stanek (Slavia Prague)", pos: "GK", rare: "rare" },

            // Defenders
            { n: "Vladimír Coufal (TSG Hoffenheim)", pos: "DF", rare: "rare" },
            { n: "David Douděra (Slavia Prague)", pos: "DF" },
            { n: "Matěj Hadaš (Sigma Olomouc)", pos: "DF" },
            { n: "Tomáš Holeš (Slavia Prague)", pos: "DF" },
            { n: "Robin Hranáč (TSG Hoffenheim)", pos: "DF", rare: "rare" },
            { n: "Štěpán Chaloupek (Slavia Prague)", pos: "DF" },
            { n: "Václav Jemelka (Viktoria Plzen)", pos: "DF" },
            { n: "David Jurásek (Slavia Prague)", pos: "DF" },
            { n: "Ladislav Krejčí (Wolverhampton Wanderers)", pos: "DF", rare: "rare" },
            { n: "Karel Spáčil (Viktoria Plzen)", pos: "DF" },
            { n: "Adam Ševínský (Sparta Prague)", pos: "DF" },
            { n: "Martin Vitík (Bologna)", pos: "DF" },
            { n: "Tomáš Vlček (Slavia Prague)", pos: "DF" },
            { n: "Jaroslav Zelený (Sparta Prague)", pos: "DF" },
            { n: "David Zima (Slavia Prague)", pos: "DF" },

            // Midfielders
            { n: "Lukas Ambros (Gornik Zabrze)", pos: "MF" },
            { n: "Michal Beran (Sigma Olomouc)", pos: "MF" },
            { n: "Pavel Bucha (FC Cincinnati)", pos: "MF" },
            { n: "Lukás Cerv (Viktoria Plzen)", pos: "MF" },
            { n: "Krystof Danek (LASK Linz)", pos: "MF" },
            { n: "Vladimir Darida (Hradec Kralove)", pos: "MF" },
            { n: "Patrik Hellebrand (Gornik Zabrze)", pos: "MF" },
            { n: "Adam Karabec (Lyon)", pos: "MF" },
            { n: "Ondrej Kricfaluši (Banik Ostrava)", pos: "MF" },
            { n: "Tomáš Ladra (Viktoria Plzen)", pos: "MF" },
            { n: "David Planka (Banik Ostrava)", pos: "MF" },
            { n: "Lukás Provod (Slavia Prague)", pos: "MF" },
            { n: "Matěj Ryneš (Sparta Prague)", pos: "MF" },
            { n: "Lukas Sadílek (Gornik Zabrze)", pos: "MF" },
            { n: "Michal Sadílek (Slavia Prague)", pos: "MF" },
            { n: "Hugo Sochůrek (Sparta Prague)", pos: "MF" },
            { n: "Alexandr Sojka (Viktoria Plzen)", pos: "MF" },
            { n: "Tomáš Souček (West Ham)", pos: "MF", rare: "rare" },
            { n: "Pavel Šulc (Lyon)", pos: "MF", rare: "rare" },
            { n: "Denis Višinský (Viktoria Plzen)", pos: "MF" },

            // Forwards
            { n: "Adam Hložek (TSG Hoffenheim)", pos: "FW", rare: "rare" },
            { n: "Tomáš Chorý (Slavia Prague)", pos: "FW" },
            { n: "Mojmír Chytil (Slavia Prague)", pos: "FW" },
            { n: "Christophe Kabongo (Mlada Boleslav)", pos: "FW" },
            { n: "Jan Kliment (Sigma Olomouc)", pos: "FW" },
            { n: "Jan Kuchta (Sparta Prague)", pos: "FW" },
            { n: "Vasil Kušej (Slavia Prague)", pos: "FW" },
            { n: "Ondřej Mihálik (Hradec Kralove)", pos: "FW" },
            { n: "Vojtěch Patrák (Pardubice)", pos: "FW" },
            { n: "Václav Sejk (Sigma Olomouc)", pos: "FW" },
            { n: "Patrik Schick (Bayer Leverkusen)", pos: "FW", rare: "legendary" },
            { n: "Matej Vydra (Viktoria Plzen)", pos: "FW" }
        ] },
    { id: "NOR", conf: "UEFA", name: "Norway", flag: f("N", "O"), c1: "#BA0C2F", c2: "#00205B",
        players: [
            // Manager
            { n: "Stale Solbakken", pos: "HC", rare: "rare" },

            // Goalkeepers
            { n: "Ørjan Nyland (Sevilla)", pos: "GK", rare: "rare" },
            { n: "Egil Selvik (Watford)", pos: "GK" },
            { n: "Sander Tangvik (Hamburg SV)", pos: "GK" },

            // Defenders
            { n: "Julian Ryerson (Borussia Dortmund)", pos: "DF", rare: "rare" },
            { n: "Kristoffer Ajer (Brentford)", pos: "DF", rare: "rare" },
            { n: "Leo Østigård (Genoa)", pos: "DF" },
            { n: "David Møller Wolfe (Wolverhampton Wanderers)", pos: "DF" },
            { n: "Marcus Pedersen (Torino)", pos: "DF" },
            { n: "Torbjørn Heggem (Bologna)", pos: "DF" },
            { n: "Fredrik André Bjørkan (Bodø/Glimt)", pos: "DF" },
            { n: "Henrik Falchener (Viking)", pos: "DF" },
            { n: "Sondre Langås (Derby County)", pos: "DF" },

            // Midfielders
            { n: "Martin Ødegaard (Arsenal)", pos: "MF", rare: "legendary" },
            { n: "Sander Berge (Fulham)", pos: "MF", rare: "rare" },
            { n: "Patrick Berg (Bodø/Glimt)", pos: "MF" },
            { n: "Kristian Thorstvedt (Sassuolo)", pos: "MF" },
            { n: "Morten Thorsby (Cremonese)", pos: "MF" },
            { n: "Thelo Aasgaard (Rangers)", pos: "MF" },
            { n: "Andreas Schjelderup (Benfica)", pos: "MF" },
            { n: "Jens Petter Hauge (Bodø/Glimt)", pos: "MF" },
            { n: "Fredrik Aursnes (Benfica)", pos: "MF", rare: "rare" },
            { n: "Oscar Bobb (Fulham)", pos: "MF", rare: "rare" },
            { n: "Antonio Nusa (RB Leipzig)", pos: "MF", rare: "rare" },

            // Forwards
            { n: "Erling Haaland (Manchester City)", pos: "FW", rare: "legendary" },
            { n: "Alexander Sørloth (Atlético Madrid)", pos: "FW", rare: "rare" },
            { n: "Jørgen Strand Larsen (Crystal Palace)", pos: "FW" }
        ] },
    { id: "SCO", conf: "UEFA", name: "Scotland", flag: "gb-sct", c1: "#0065BF", c2: "#FFFFFF",
        players: [
            // Manager
            { n: "Steve Clarke", pos: "HC", rare: "rare" },

            // Goalkeepers
            { n: "Craig Gordon (Hearts)", pos: "GK" },
            { n: "Angus Gunn (Nottingham Forest)", pos: "GK" },
            { n: "Liam Kelly (Rangers)", pos: "GK" },

            // Defenders
            { n: "Grant Hanley (Hibernian)", pos: "DF" },
            { n: "Jack Hendry (Al Etiffaq)", pos: "DF" },
            { n: "Aaron Hickey (Brentford)", pos: "DF" },
            { n: "Dom Hyam (Wrexham)", pos: "DF" },
            { n: "Scott McKenna (Dinamo Zagreb)", pos: "DF" },
            { n: "Nathan Patterson (Everton)", pos: "DF" },
            { n: "Anthony Ralston (Celtic)", pos: "DF" },
            { n: "Andy Robertson (Liverpool)", pos: "DF", rare: "legendary" },
            { n: "John Souttar (Rangers)", pos: "DF" },
            { n: "Kieran Tierney (Celtic)", pos: "DF", rare: "rare" },

            // Midfielders
            { n: "Ryan Christie (Bournemouth)", pos: "MF" },
            { n: "Finlay Curtis (Kilmarnock)", pos: "MF" },
            { n: "Lewis Ferguson (Bologna)", pos: "MF", rare: "rare" },
            { n: "Ben Gannon-Doak (Bournemouth)", pos: "MF" },
            { n: "Billy Gilmour (Napoli)", pos: "MF", rare: "rare" },
            { n: "John McGinn (Aston Villa)", pos: "MF", rare: "rare" },
            { n: "Kenny McLean (Norwich)", pos: "MF" },
            { n: "Scott McTominay (Napoli)", pos: "MF", rare: "rare" },

            // Forwards
            { n: "Ché Adams (Torino)", pos: "FW" },
            { n: "Lyndon Dykes (Charlton Athletic)", pos: "FW" },
            { n: "George Hirst (Ipswich)", pos: "FW" },
            { n: "Lawrence Shankland (Hearts)", pos: "FW", rare: "rare" },
            { n: "Ross Stewart (Southampton)", pos: "FW" }
        ] },
    { id: "SWE", conf: "UEFA", name: "Sweden", flag: f("S", "E"), c1: "#006AA7", c2: "#FECC00",
        players: [
            // Manager
            { n: "Graham Potter", pos: "HC", rare: "rare" },

            // Goalkeepers
            { n: "Viktor Johansson (Stoke City)", pos: "GK", rare: "rare" },
            { n: "Kristoffer Nordfeldt (AIK)", pos: "GK" },
            { n: "Jacob Widell Zetterstrom (Derby County)", pos: "GK" },

            // Defenders
            { n: "Hjalmar Ekdal (Burnley)", pos: "DF" },
            { n: "Gabriel Gudmundsson (Leeds United)", pos: "DF" },
            { n: "Isak Hien (Atalanta)", pos: "DF", rare: "rare" },
            { n: "Emil Holm (Juventus)", pos: "DF" },
            { n: "Gustaf Lagerbielke (Braga)", pos: "DF" },
            { n: "Victor Lindelöf (Aston Villa)", pos: "DF", rare: "rare" },
            { n: "Erik Smith (St. Pauli)", pos: "DF" },
            { n: "Carl Starfelt (Celta Vigo)", pos: "DF" },
            { n: "Elliot Stroud (Mjallby)", pos: "DF" },
            { n: "Daniel Svensson (Borussia Dortmund)", pos: "DF", rare: "rare" },

            // Midfielders
            { n: "Taha Ali (Malmo)", pos: "MF" },
            { n: "Yasin Ayari (Brighton)", pos: "MF" },
            { n: "Lucas Bergvall (Tottenham)", pos: "MF", rare: "rare" },
            { n: "Jesper Karlström (Udinese)", pos: "MF" },
            { n: "Ken Sema (Pafos)", pos: "MF" },
            { n: "Mattias Svanberg (Wolfsburg)", pos: "MF", rare: "rare" },
            { n: "Besfort Zeneli (Union St-Gilloise)", pos: "MF" },

            // Forwards
            { n: "Alexander Bernhardsson (Holstein Kiel)", pos: "FW" },
            { n: "Anthony Elanga (Newcastle United)", pos: "FW", rare: "rare" },
            { n: "Viktor Gyökeres (Arsenal)", pos: "FW", rare: "legendary" },
            { n: "Alexander Isak (Liverpool)", pos: "FW", rare: "legendary" },
            { n: "Gustaf Nilsson (Club Brugge)", pos: "FW" },
            { n: "Benjamin Nygren (Celtic)", pos: "FW" }
        ] },
    { id: "SUI", conf: "UEFA", name: "Switzerland", flag: f("C", "H"), c1: "#DA291C", c2: "#FFFFFF",
        players: [
            // Goalkeepers
            { n: "Gregor Kobel (Borussia Dortmund)", pos: "GK", rare: "rare" },
            { n: "Yvon Mvogo (Lorient)", pos: "GK" },
            { n: "Marvin Keller (Young Boys)", pos: "GK" },

            // Defenders
            { n: "Manuel Akanji (Inter Milan)", pos: "DF", rare: "rare" },
            { n: "Nico Elvedi (Borussia Mönchengladbach)", pos: "DF" },
            { n: "Ricardo Rodriguez (Real Betis)", pos: "DF" },
            { n: "Silvan Widmer (Mainz)", pos: "DF" },
            { n: "Miro Muheim (Hamburger SV)", pos: "DF" },
            { n: "Aurèle Amenda (Eintracht Frankfurt)", pos: "DF" },
            { n: "Eray Cömert (Valencia)", pos: "DF" },
            { n: "Luca Jaquez (Stuttgart)", pos: "DF" },

            // Midfielders
            { n: "Granit Xhaka (Sunderland)", pos: "MF", rare: "legendary" },
            { n: "Johan Manzambi (Freiburg)", pos: "MF" },
            { n: "Remo Freuler (Bologna)", pos: "MF", rare: "rare" },
            { n: "Denis Zakaria (Monaco)", pos: "MF", rare: "rare" },
            { n: "Ardon Jashari (AC Milan)", pos: "MF" },
            { n: "Djibril Sow (Sevilla)", pos: "MF" },
            { n: "Christian Fassnacht (Young Boys)", pos: "MF" },
            { n: "Michel Aebischer (Pisa)", pos: "MF" },
            { n: "Fabian Rieder (Augsburg)", pos: "MF" },
            { n: "Rubén Vargas (Sevilla)", pos: "MF" },

            // Forwards
            { n: "Breel Embolo (Rennes)", pos: "FW", rare: "rare" },
            { n: "Noah Okafor (Leeds)", pos: "FW", rare: "rare" },
            { n: "Dan Ndoye (Nottingham Forest)", pos: "FW" },
            { n: "Zeki Amdouni (Burnley)", pos: "FW" },
            { n: "Cedric Itten (Fortuna Dusseldorf)", pos: "FW" }
        ] },
    { id: "TUR", conf: "UEFA", name: "Türkiye", flag: f("T", "R"), c1: "#E30A17", c2: "#FFFFFF",
        players: [
            // Manager
            { n: "Vincenzo Montella", pos: "HC", rare: "rare" },

            // Goalkeepers
            { n: "Ugurcan Cakir (Galatasaray)", pos: "GK", rare: "rare" },
            { n: "Mert Gunok (Fenerbahce)", pos: "GK", rare: "rare" },
            { n: "Altay Bayindir (Man United)", pos: "GK" },
            { n: "Muhammed Sengezer (Istanbul Basaksehir)", pos: "GK" },
            { n: "Ersin Destanoglou (Besiktas)", pos: "GK" },

            // Defenders
            { n: "Merih Demiral (Al-Ahli)", pos: "DF", rare: "rare" },
            { n: "Zeki Celik (AS Roma)", pos: "DF" },
            { n: "Caglar Soyuncu (Fenerbahce)", pos: "DF", rare: "rare" },
            { n: "Mert Muldur (Fenerbahce)", pos: "DF" },
            { n: "Ferdi Kadioglu (Brighton & Hove Albion)", pos: "DF", rare: "rare" },
            { n: "Ozan Kabak (TSG Hoffenheim)", pos: "DF" },
            { n: "Abdulkerim Bardakci (Galatasaray)", pos: "DF" },
            { n: "Eren Elmali (Galatasaray)", pos: "DF" },
            { n: "Samet Akaydin (Caykur Rizesport)", pos: "DF" },
            { n: "Mustafa Eskihellac (Trabzonspor)", pos: "DF" },
            { n: "Yusuf Akcicek (Al-Hilal)", pos: "DF" },
            { n: "Ahmetcan Kaplan (NEC Nijmegen)", pos: "DF" },

            // Midfielders
            { n: "Hakan Calhanoglou (Inter Milan)", pos: "MF", rare: "rare" },
            { n: "Kaan Ayhan (Galatasaray)", pos: "MF" },
            { n: "Orkun Kokcu (Besiktas)", pos: "MF", rare: "rare" },
            { n: "Ismail Yuksek (Fenerbahce)", pos: "MF" },
            { n: "Salih Ozcan (Borussia Dortmund)", pos: "MF" },
            { n: "Atakan Karazor (VfB Stuttgart)", pos: "MF" },
            { n: "Demir Ege Tiknaz (Besiktas)", pos: "MF" },

            // Forwards
            { n: "Kerem Akturkoglu (Fenerbahce)", pos: "FW", rare: "rare" },
            { n: "Irfan Can Kahveci (Kasimpasa)", pos: "FW" },
            { n: "Baris Apler Yilmaz (Galatasaray)", pos: "FW", rare: "rare" },
            { n: "Arda Guler (Real Madrid)", pos: "FW", rare: "legendary" },
            { n: "Kenan Yildiz (Juventus)", pos: "FW", rare: "rare" },
            { n: "Yunus Akgun (Galatasaray)", pos: "FW" },
            { n: "Oguz Aydin (Fenerbahce)", pos: "FW" },
            { n: "Deniz Gul (Porto)", pos: "FW" },
            { n: "Yusuf Sari (Basaksehir)", pos: "FW" },
            { n: "Can Uzun (Eintracht Frankfurt)", pos: "FW" },
            { n: "Aral Simsir (Midtjylland)", pos: "FW" }
        ] },

    // CONMEBOL
    { id: "ARG", conf: "CONMEBOL", name: "Argentina", flag: f("A", "R"), c1: "#74ACDF", c2: "#FFFFFF",
        players: [
            // Manager
            { n: "Lionel Scaloni", pos: "HC", rare: "rare" },

            // Goalkeepers
            { n: "Emiliano Martínez (Aston Villa)", pos: "GK", rare: "rare" },
            { n: "Gerónimo Rulli (Olympique de Marseille)", pos: "GK" },
            { n: "Juan Musso (Atletico Madrid)", pos: "GK" },
            { n: "Walter Benítez (Crystal Palace)", pos: "GK" },
            { n: "Facundo Cambeses (Racing Club)", pos: "GK" },
            { n: "Santiago Beltran (River Plate)", pos: "GK" },

            // Defenders
            { n: "Agustín Giay (Palmeiras)", pos: "DF" },
            { n: "Gonzalo Montiel (River Plate)", pos: "DF", rare: "rare" },
            { n: "Nahuel Molina (Atletico Madrid)", pos: "DF" },
            { n: "Nicolás Capaldo (Hamburger)", pos: "DF" },
            { n: "Kevin Mac Allister (Union Saint Gilloise)", pos: "DF" },
            { n: "Lucas Martínez Quarta (River Plate)", pos: "DF" },
            { n: "Marcos Senesi (Bournemouth)", pos: "DF" },
            { n: "Lisandro Martínez (Manchester United)", pos: "DF", rare: "rare" },
            { n: "Nicolás Otamendi (Benfica)", pos: "DF", rare: "rare" },
            { n: "Germán Pezzella (River Plate)", pos: "DF" },
            { n: "Leonardo Balerdi (Marseille)", pos: "DF" },
            { n: "Cristian Romero (Tottenham)", pos: "DF", rare: "rare" },
            { n: "Lautaro Di Lollo (Boca Juniors)", pos: "DF" },
            { n: "Zaid Romero (Getafe)", pos: "DF" },
            { n: "Facundo Medina (Marseille)", pos: "DF" },
            { n: "Marcos Acuña (River Plate)", pos: "DF", rare: "rare" },
            { n: "Nicolás Tagliafico (Lyon)", pos: "DF" },
            { n: "Gabriel Rojas (Racing Club)", pos: "DF" },

            // Midfielders
            { n: "Máximo Perrone (Como)", pos: "MF" },
            { n: "Leandro Paredes (Boca Juniors)", pos: "MF", rare: "rare" },
            { n: "Guido Rodríguez (Valencia)", pos: "MF" },
            { n: "Anibal Moreno (River Plate)", pos: "MF" },
            { n: "Milton Delgado (Boca Juniors)", pos: "MF" },
            { n: "Alan Varela (Porto)", pos: "MF" },
            { n: "Ezequiel Fernández (Bayer Leverkusen)", pos: "MF", rare: "rare" },
            { n: "Rodrigo De Paul (Inter Miami)", pos: "MF", rare: "rare" },
            { n: "Exequiel Palacios (Bayer Leverkusen)", pos: "MF", rare: "rare" },
            { n: "Enzo Fernández (Chelsea)", pos: "MF", rare: "rare" },
            { n: "Alexis Mac Allister (Liverpool)", pos: "MF", rare: "rare" },
            { n: "Giovani Lo Celso (Real Betis)", pos: "MF" },
            { n: "Nicolas Domínguez (Nottingham Forest)", pos: "MF" },
            { n: "Emiliano Buendía (Aston Villa)", pos: "MF" },
            { n: "Valentín Barco (Strasbourg)", pos: "MF" },

            // Forwards
            { n: "Lionel Messi (Inter Miami)", pos: "FW", rare: "legendary" },
            { n: "Nicolas Paz (Como)", pos: "FW", rare: "rare" },
            { n: "Franco Mastantuono (Real Madrid)", pos: "FW", rare: "rare" },
            { n: "Thiago Almada (Atletico Madrid)", pos: "FW", rare: "rare" },
            { n: "Tomas Aranda (Boca Juniors)", pos: "FW" },
            { n: "Nicolás González (Atletico Madrid)", pos: "FW" },
            { n: "Alejandro Garnacho (Chelsea)", pos: "FW", rare: "rare" },
            { n: "Giuliano Simeone (Atletico Madrid)", pos: "FW" },
            { n: "Matías Soule (Roma)", pos: "FW", rare: "rare" },
            { n: "Claudio Echeverri (Girona)", pos: "FW", rare: "rare" },
            { n: "Gianluca Prestianni (Benfica)", pos: "FW" },
            { n: "Santiago Castro (Bologna)", pos: "FW" },
            { n: "Lautaro Martínez (Inter Milan)", pos: "FW", rare: "legendary" },
            { n: "Jose Manuel Lopez (Palmeiras)", pos: "FW" },
            { n: "Julián Álvarez (Atletico Madrid)", pos: "FW", rare: "legendary" },
            { n: "Mateo Pellegrino (Parma)", pos: "FW" }
        ] },
    { id: "BRA", conf: "CONMEBOL", name: "Brazil", flag: f("B", "R"), c1: "#009C3B", c2: "#FFDF00",
        players: [
            // Manager
            { n: "Carlo Ancelotti", pos: "HC", rare: "rare" },

            // Goalkeepers
            { n: "Alisson (Liverpool)", pos: "GK", rare: "rare" },
            { n: "Éderson (Fenerbahce)", pos: "GK", rare: "rare" },
            { n: "Weverton (Grêmio)", pos: "GK" },

            // Defenders
            { n: "Alex Sandro (Flamengo)", pos: "DF" },
            { n: "Bremer (Juventus)", pos: "DF", rare: "rare" },
            { n: "Danilo (Flamengo)", pos: "DF" },
            { n: "Douglas Santos (Zenit St. Petersburg)", pos: "DF" },
            { n: "Gabriel Magalhães (Arsenal)", pos: "DF", rare: "rare" },
            { n: "Léo Pereira (Flamengo)", pos: "DF" },
            { n: "Marquinhos (Paris Saint-Germain)", pos: "DF", rare: "rare" },
            { n: "Roger Ibañez (Al Ahli)", pos: "DF" },
            { n: "Wesley (AS Roma)", pos: "DF" },

            // Midfielders
            { n: "Bruno Guimarães (Newcastle United)", pos: "MF", rare: "rare" },
            { n: "Casemiro (Manchester United)", pos: "MF", rare: "rare" },
            { n: "Danilo Santos (Botafogo)", pos: "MF" },
            { n: "Fabinho (Al Ittihad)", pos: "MF" },
            { n: "Lucas Paquetá (Flamengo)", pos: "MF", rare: "rare" },

            // Forwards
            { n: "Endrick (Lyon)", pos: "FW", rare: "rare" },
            { n: "Gabriel Martinelli (Arsenal)", pos: "FW" },
            { n: "Igor Thiago (Brentford)", pos: "FW" },
            { n: "Luiz Henrique (Zenit St. Petersburg)", pos: "FW" },
            { n: "Matheus Cunha (Manchester United)", pos: "FW" },
            { n: "Neymar (Santos)", pos: "FW", rare: "legendary" },
            { n: "Raphinha (Barcelona)", pos: "FW", rare: "rare" },
            { n: "Rayan (Bournemouth)", pos: "FW" },
            { n: "Vinícius Júnior (Real Madrid)", pos: "FW", rare: "legendary" }
        ] },
    { id: "COL", conf: "CONMEBOL", name: "Colombia", flag: f("C", "O"), c1: "#FCD116", c2: "#003893",
        players: [
            // Manager
            { n: "Nestor Lorenzo", pos: "HC", rare: "rare" },

            // Goalkeepers
            { n: "David Ospina (Atlético Nacional)", pos: "GK", rare: "rare" },
            { n: "Álvaro Montero (Vélez Sarsfield)", pos: "GK" },
            { n: "Camilo Vargas (Atlas)", pos: "GK", rare: "rare" },
            { n: "Mosquera Marmolejo (Independiente Santa Fe)", pos: "GK" },
            { n: "Aldair Quintana (Independiente del Valle)", pos: "GK" },
            { n: "Kevin Mier (Cruz Azul)", pos: "GK", rare: "rare" },

            // Defenders
            { n: "Daniel Muñoz (Crystal Palace)", pos: "DF", rare: "rare" },
            { n: "Jhon Lucumí (Bologna)", pos: "DF", rare: "rare" },
            { n: "Álvaro Angulo (Pumas)", pos: "DF" },
            { n: "Santiago Arias (Independiente)", pos: "DF" },
            { n: "Davinson Sánchez (Galatasaray)", pos: "DF", rare: "rare" },
            { n: "Johan Mojica (Mallorca)", pos: "DF" },
            { n: "Yerry Mina (Cagliari)", pos: "DF", rare: "rare" },
            { n: "Cristian Borja (Club América)", pos: "DF" },
            { n: "Juan Cabal (Juventus)", pos: "DF", rare: "rare" },
            { n: "Carlos Cuesta (Vasco da Gama)", pos: "DF" },
            { n: "Willer Ditta (Cruz Azul)", pos: "DF" },
            { n: "Junior Hernández (Deportes Tolima)", pos: "DF" },
            { n: "Deiver Machado (Nantes)", pos: "DF" },
            { n: "Yerson Mosquera (Wolverhampton Wanderers)", pos: "DF" },
            { n: "Édier Ocampo (Vancouver Whitecaps)", pos: "DF" },
            { n: "Jhohan Romaña (San Lorenzo)", pos: "DF" },
            { n: "Andrés Román (Atlético Nacional)", pos: "DF" },

            // Midfielders
            { n: "Jorge Carrascal (Flamengo)", pos: "MF" },
            { n: "Sebastian Gomez (Coritiba)", pos: "MF" },
            { n: "Nelson Deossa (Real Betis)", pos: "MF" },
            { n: "Kevin Castaño (River Plate)", pos: "MF" },
            { n: "Gustavo Puerta (Racing Santander)", pos: "MF" },
            { n: "Juan Manuel Rengifo (Atlético Nacional)", pos: "MF" },
            { n: "Johan Rojas (Vasco da Gama)", pos: "MF" },
            { n: "Juan Fernando Quintero (River Plate)", pos: "MF", rare: "rare" },
            { n: "Juan Portilla (Athletico Paranaense)", pos: "MF" },
            { n: "Jordan Barrera (Botafogo)", pos: "MF" },
            { n: "Jhon Solís (Birmingham City)", pos: "MF" },
            { n: "Jefferson Lerma (Crystal Palace)", pos: "MF", rare: "rare" },
            { n: "Richard Ríos (Benfica)", pos: "MF", rare: "rare" },
            { n: "Jhon Arias (Palmeiras)", pos: "MF", rare: "rare" },
            { n: "Wilmar Barrios (Zenit St. Petersburg)", pos: "MF" },
            { n: "Juan Cuadrado (Pisa)", pos: "MF", rare: "rare" },
            { n: "Yáser Asprilla (Galatasaray)", pos: "MF", rare: "rare" },
            { n: "James Rodríguez (Minnesota United)", pos: "MF", rare: "legendary" },

            // Forwards
            { n: "Luis Díaz (Bayern Munich)", pos: "FW", rare: "legendary" },
            { n: "Jhon Córdoba (Krasnodar)", pos: "FW", rare: "rare" },
            { n: "Luis Suárez (Sporting CP)", pos: "FW" },
            { n: "Sebastián Villa (Independiente Rivadavia)", pos: "FW" },
            { n: "Neyser Villarreal (Cruzeiro)", pos: "FW" },
            { n: "Kevin Viveros (Athletico Paranaense)", pos: "FW" },
            { n: "Stiven Mendoza (Athletico Paranaense)", pos: "FW" },
            { n: "Edwuin Cetré (Estudiantes de La Plata)", pos: "FW" },
            { n: "Jhon Durán (Zenit St. Petersburg)", pos: "FW", rare: "rare" },
            { n: "Andrés Gómez (Vasco da Gama)", pos: "FW" },
            { n: "Rafael Santos Borré (Internacional)", pos: "FW", rare: "rare" },
            { n: "Jaminton Campaz (Rosario Central)", pos: "FW" },
            { n: "Johan Carbonero (Internacional)", pos: "FW" },
            { n: "Cucho Hernández (Real Betis)", pos: "FW", rare: "rare" }
        ] },
    { id: "ECU", conf: "CONMEBOL", name: "Ecuador", flag: f("E", "C"), c1: "#FFDD00", c2: "#0033A0",
        players: [
            // Manager
            { n: "Sebastián Beccacece", pos: "HC", rare: "rare" },

            // Goalkeepers
            { n: "Hernán Galíndez (Huracán)", pos: "GK", rare: "rare" },
            { n: "Moisés Ramírez (AE Kifisias)", pos: "GK" },
            { n: "Gonzalo Valle (LDU Quito)", pos: "GK" },

            // Defenders
            { n: "Willian Pacho (Paris Saint-Germain)", pos: "DF", rare: "rare" },
            { n: "Piero Hincapié (Arsenal)", pos: "DF", rare: "rare" },
            { n: "Joel Ordóñez (Club Brugge)", pos: "DF" },
            { n: "Félix Torres (Internacional)", pos: "DF" },
            { n: "Pervis Estupiñán (AC Milan)", pos: "DF", rare: "rare" },
            { n: "Yaimar Medina (Racing Genk)", pos: "DF" },
            { n: "Ángelo Preciado (Atlético Mineiro)", pos: "DF" },
            { n: "Jackson Porozo (Club Tijuana)", pos: "DF" },

            // Midfielders
            { n: "Alan Minda (Atlético Mineiro)", pos: "MF" },
            { n: "Moisés Caicedo (Chelsea)", pos: "MF", rare: "legendary" },
            { n: "Jordy Alcivar (Independiente del Valle)", pos: "MF" },
            { n: "Denil Castillo (FC Midtjylland)", pos: "MF" },
            { n: "John Yeboah (Venezia)", pos: "MF" },
            { n: "Alan Franco (Atlético Mineiro)", pos: "MF" },
            { n: "Pedro Vite (Pumas UNAM)", pos: "MF" },
            { n: "Kendry Páez (River Plate)", pos: "MF", rare: "rare" },
            { n: "Nilson Angulo (Sunderland)", pos: "MF" },
            { n: "Gonzalo Plata (Flamengo)", pos: "MF" },

            // Forwards
            { n: "Kevin Rodríguez (Union St.-Gilloise)", pos: "FW" },
            { n: "Anthony Valencia (Antwerp)", pos: "FW" },
            { n: "Enner Valencia (Pachuca)", pos: "FW", rare: "rare" },
            { n: "Jordy Caicedo (Huracán)", pos: "FW" },
            { n: "Jeremy Arévalo (VfB Stuttgart)", pos: "FW" }
        ] },
    { id: "PAR", conf: "CONMEBOL", name: "Paraguay", flag: f("P", "Y"), c1: "#D52B1E", c2: "#0038A8",
        players: [
            // Manager
            { n: "Gustavo Alfaro", pos: "HC", rare: "rare" },

            // Goalkeepers
            { n: "Roberto Fernández (Cerro Porteño)", pos: "GK" },
            { n: "Orlando Gill (San Lorenzo)", pos: "GK" },
            { n: "Gastón Olveira (Olimpia)", pos: "GK" },
            { n: "Carlos Coronel (Sao Paulo)", pos: "GK", rare: "rare" },
            { n: "Santiago Rojas (Nacional)", pos: "GK" },
            { n: "Juan Espínola (Barracas Central)", pos: "GK" },

            // Defenders
            { n: "Gustavo Gómez (Palmeiras)", pos: "DF", rare: "rare" },
            { n: "Júnior Alonso (Atletico Mineiro)", pos: "DF" },
            { n: "Fabián Balbuena (Gremio)", pos: "DF" },
            { n: "Omar Alderete (Sunderland)", pos: "DF", rare: "rare" },
            { n: "Juan Caceres (Dynamo Moscow)", pos: "DF" },
            { n: "Blas Riveros (Cerro Porteno)", pos: "DF" },
            { n: "Alan Benitez (Libertad)", pos: "DF" },
            { n: "Agustin Sandez (Rosario Central)", pos: "DF" },
            { n: "Mateo Gamarra (Cruzeiro)", pos: "DF" },
            { n: "Saul Salcedo (Newell's Old Boys)", pos: "DF" },
            { n: "Jose Canale (Lanus)", pos: "DF" },
            { n: "Diego León (Manchester United)", pos: "DF", rare: "rare" },
            { n: "Alexandro Maidana (Talleres)", pos: "DF" },
            { n: "Alcides Benitez (Belgrano)", pos: "DF" },
            { n: "Ronaldo Dejesus (Lanus)", pos: "DF" },
            { n: "Alan Nuñez (Nacional)", pos: "DF" },

            // Midfielders
            { n: "Miguel Almirón (Atlanta United)", pos: "MF", rare: "legendary" },
            { n: "Mathías Villasanti (Gremio)", pos: "MF", rare: "rare" },
            { n: "Kaku (Al Ain)", pos: "MF" },
            { n: "Andrés Cubas (Vancouver Whitecaps)", pos: "MF" },
            { n: "Ramón Sosa (Palmeiras)", pos: "MF", rare: "rare" },
            { n: "Diego Gómez (Brighton & Hove Albion)", pos: "MF", rare: "rare" },
            { n: "Damián Bobadilla (Sao Paulo)", pos: "MF" },
            { n: "Braian Ojeda (Orlando City)", pos: "MF" },
            { n: "Matías Galarza (Atlanta United)", pos: "MF" },
            { n: "Robert Piris Da Motta (Cerro Porteno)", pos: "MF" },
            { n: "Alvaro Campuzano (Libertad)", pos: "MF" },
            { n: "Diego Gonzalez (Atlas)", pos: "MF" },
            { n: "Hugo Cuenca (Burgos)", pos: "MF" },
            { n: "Mauricio Magalhaes (Palmeiras)", pos: "MF" },
            { n: "Lucas Romero (Universidad de Chile)", pos: "MF" },
            { n: "Enso González (Wolverhampton Wanderers)", pos: "MF" },
            { n: "Ruben Lezcano (Olimpia)", pos: "MF" },

            // Forwards
            { n: "Oscar Romero (Huracan)", pos: "FW" },
            { n: "Ángel Romero (Boca Juniors)", pos: "FW", rare: "rare" },
            { n: "Antonio Sanabria (Cremonese)", pos: "FW", rare: "rare" },
            { n: "Julio Enciso (Strasbourg)", pos: "FW", rare: "legendary" },
            { n: "Gabriel Avalos (Independiente)", pos: "FW" },
            { n: "Carlos Gonzalez (Independiente del Valle)", pos: "FW" },
            { n: "Alex Arce (Independiente Rivadavia)", pos: "FW", rare: "rare" },
            { n: "Adam Bareiro (Boca Juniors)", pos: "FW", rare: "rare" },
            { n: "Lorenzo Melgarejo (Libertad)", pos: "FW" },
            { n: "Isidro Pitta (Red Bull Bragantino)", pos: "FW" },
            { n: "Ronaldo Martinez (Talleres)", pos: "FW" },
            { n: "Gustavo Caballero (Portsmouth)", pos: "FW" },
            { n: "Robert Morales (UNAM)", pos: "FW" },
            { n: "Adrian Alcaraz (Olimpia)", pos: "FW" },
            { n: "Rodney Redes (LDU Quito)", pos: "FW" }
        ] },
    { id: "URU", conf: "CONMEBOL", name: "Uruguay", flag: f("U", "Y"), c1: "#5AAAD0", c2: "#FFFFFF",
        players: [
            // Manager
            { n: "Marcelo Bielsa", pos: "HC", rare: "rare" },

            // Goalkeepers
            { n: "Fernando Muslera (Estudiantes de La Plata)", pos: "GK", rare: "rare" },
            { n: "Sergio Rochet (Internacional de Porto Alegre)", pos: "GK", rare: "rare" },
            { n: "Santiago Mele (Monterrey)", pos: "GK" },

            // Defenders
            { n: "Ronald Araújo (Barcelona)", pos: "DF", rare: "rare" },
            { n: "José María Giménez (Atlético Madrid)", pos: "DF", rare: "rare" },
            { n: "Santiago Bueno (Wolverhampton Wanderers)", pos: "DF" },
            { n: "Sebastián Cáceres (América)", pos: "DF" },
            { n: "Mathías Olivera (Napoli)", pos: "DF" },
            { n: "Guillermo Varela (Flamengo)", pos: "DF" },
            { n: "Matías Viña (River Plate)", pos: "DF" },
            { n: "Joaquín Piquerez (Palmeiras)", pos: "DF" },
            { n: "Juan Manuel Sanabria (Real Salt Lake)", pos: "DF" },

            // Midfielders
            { n: "Federico Valverde (Real Madrid)", pos: "MF", rare: "legendary" },
            { n: "Rodrigo Bentancur (Tottenham Hotspur)", pos: "MF", rare: "rare" },
            { n: "Manuel Ugarte (Manchester United)", pos: "MF", rare: "rare" },
            { n: "Emiliano Martínez (Palmeiras)", pos: "MF" },
            { n: "Rodrigo Zalazar (Sporting CP)", pos: "MF" },
            { n: "Giorgian De Arrascaeta (Flamengo)", pos: "MF" },
            { n: "Nicolás De La Cruz (Flamengo)", pos: "MF" },
            { n: "Agustín Canobbio (Fluminense)", pos: "MF" },
            { n: "Maximiliano Araújo (Sporting CP)", pos: "MF" },
            { n: "Brian Rodríguez (América)", pos: "MF" },
            { n: "Facundo Pellistri (Panathinaikos)", pos: "MF" },

            // Forwards
            { n: "Darwin Núñez (Al Hilal)", pos: "FW", rare: "rare" },
            { n: "Federico Viñas (Real Oviedo)", pos: "FW" },
            { n: "Rodrigo Aguirre (Tigres)", pos: "FW" }
        ] },

    // CAF
    { id: "EGY", conf: "CAF", name: "Egypt", flag: f("E", "G"), c1: "#CE1126", c2: "#FFFFFF",
        players: [
            // Manager
            { n: "Hossam Hassan", pos: "HC", rare: "rare" },

            // Goalkeepers
            { n: "Mohamed El Shenawy (Al Ahly)", pos: "GK", rare: "rare" },
            { n: "Mostafa Shobeir (Al Ahly)", pos: "GK" },
            { n: "El Mahdi Soliman (Zamalek)", pos: "GK" },
            { n: "Mohamed Alaa (El Gouna)", pos: "GK" },

            // Defenders
            { n: "Mohamed Hany (Al Ahly)", pos: "DF" },
            { n: "Tarek Alaa (Zed)", pos: "DF" },
            { n: "Hamdy Fathy (Al Wakrah)", pos: "DF" },
            { n: "Rami Rabia (Al Ain)", pos: "DF" },
            { n: "Yasser Ibrahim (Al Ahly)", pos: "DF" },
            { n: "Hossam Abdelmaguid (Zamalek)", pos: "DF" },
            { n: "Mohamed Abdelmonemn (Nice)", pos: "DF", rare: "rare" },
            { n: "Ahmed Fatouh (Zamalek)", pos: "DF" },
            { n: "Karim Hafez (Pyramids)", pos: "DF" },

            // Midfielders
            { n: "Marwan Ateya (Al Ahly)", pos: "MF" },
            { n: "Mohanad Lasheen (Pyramids)", pos: "MF" },
            { n: "Nabil Emad (Al Najma)", pos: "MF" },
            { n: "Mahmoud Saber (Zed)", pos: "MF" },
            { n: "Ahmed Zizo (Al Ahly)", pos: "MF", rare: "rare" },
            { n: "Emam Ashour (Al Ahly)", pos: "MF", rare: "rare" },
            { n: "Mostafa Ziko (Pyramids)", pos: "MF" },
            { n: "Mahmoud Trezeguet (Al Ahly)", pos: "MF", rare: "rare" },
            { n: "Ibrahim Adel (Nordsjaelland)", pos: "MF" },
            { n: "Haissem Hassan (Real Ovideo)", pos: "MF" },

            // Forwards
            { n: "Omar Marmoush (Manchester City)", pos: "FW", rare: "rare" },
            { n: "Mohamed Salah (Liverpool)", pos: "FW", rare: "legendary" },
            { n: "Aqtay Abdallah (Enppi)", pos: "FW" },
            { n: "Hamza Abdelkarim (Barcelona)", pos: "FW", rare: "rare" }
        ] },
    { id: "MAR", conf: "CAF", name: "Morocco", flag: f("M", "A"), c1: "#C1272D", c2: "#006233",
        players: [
            // Manager
            { n: "Mohamed Ouahbi", pos: "HC", rare: "rare" },

            // Goalkeepers
            { n: "Yassine Bounou (Al Hilal)", pos: "GK", rare: "legendary" },
            { n: "Munir El Kajoui (RS Berkane)", pos: "GK" },
            { n: "Reda Tagnaouti (AS Far)", pos: "GK" },

            // Defenders
            { n: "Noussair Mazraoui (Manchester United)", pos: "DF", rare: "rare" },
            { n: "Anass Salah-Eddine (PSV Eindhoven)", pos: "DF" },
            { n: "Youssef Belammari (Al Ahly)", pos: "DF" },
            { n: "Achraf Hakimi (Paris Saint-Germain)", pos: "DF", rare: "legendary" },
            { n: "Zakaria El Ouahdi (Racing Genk)", pos: "DF" },
            { n: "Chadi Riad (Crystal Palace)", pos: "DF" },
            { n: "Nayef Aguerd (Marseille)", pos: "DF", rare: "rare" },
            { n: "Redouane Halhal (KV Mechelen)", pos: "DF" },
            { n: "Issa Diop (Fulham)", pos: "DF" },

            // Midfielders
            { n: "Samir El Mourabet (Strasbourg)", pos: "MF" },
            { n: "Ayyoub Bouaddi (Lille)", pos: "MF" },
            { n: "Neil El Aynaoui (AS Roma)", pos: "MF" },
            { n: "Sofyan Amrabat (Real Betis)", pos: "MF", rare: "rare" },
            { n: "Azzedine Ounahi (Girona)", pos: "MF", rare: "rare" },
            { n: "Bilal El Khannouss (Stuttgart)", pos: "MF", rare: "rare" },
            { n: "Ismael Saibari (PSV Eindhoven)", pos: "MF" },

            // Forwards
            { n: "Abde Ezzalzouli (Real Betis)", pos: "FW", rare: "rare" },
            { n: "Chemsdine Talbi (Sunderland)", pos: "FW" },
            { n: "Soufiane Rahimi (Al Ain)", pos: "FW", rare: "rare" },
            { n: "Ayoub El Kaabi (Olympiacos)", pos: "FW", rare: "rare" },
            { n: "Brahim Díaz (Real Madrid)", pos: "FW", rare: "legendary" },
            { n: "Gessime Yassine (Strasbourg)", pos: "FW" },
            { n: "Ayoube Amaimouni (Eintracht Frankfurt)", pos: "FW" }
        ] },
    { id: "SEN", conf: "CAF", name: "Senegal", flag: f("S", "N"), c1: "#00853F", c2: "#FFD700",
        players: [
            // Manager
            { n: "Pape Thiaw", pos: "HC", rare: "rare" },

            // Goalkeepers
            { n: "Édouard Mendy (Al Ahli)", pos: "GK", rare: "rare" },
            { n: "Mory Diaw (Le Havre AC)", pos: "GK" },
            { n: "Yehvann Diouf (OGC Nice)", pos: "GK" },

            // Defenders
            { n: "Krépin Diatta (AS Monaco)", pos: "DF" },
            { n: "Antoine Mendy (OGC Nice)", pos: "DF" },
            { n: "Kalidou Koulibaly (Al Hilal)", pos: "DF", rare: "rare" },
            { n: "El Hadji Malick Diouf (West Ham United)", pos: "DF" },
            { n: "Mamadou Sarr (Chelsea)", pos: "DF" },
            { n: "Moussa Niakhaté (Lyon)", pos: "DF" },
            { n: "Moustapha Mbow (Paris FC)", pos: "DF" },
            { n: "Abdoulaye Seck (Maccabi Haifa)", pos: "DF" },
            { n: "Ismail Jakobs (Galatasaray)", pos: "DF" },
            { n: "Ilay Camara (Anderlecht)", pos: "DF" },

            // Midfielders
            { n: "Idrissa Gana Gueye (Everton)", pos: "MF", rare: "rare" },
            { n: "Pape Gueye (Villarreal CF)", pos: "MF" },
            { n: "Lamine Camara (AS Monaco)", pos: "MF" },
            { n: "Habib Diarra (Sunderland)", pos: "MF" },
            { n: "Pathé Ciss (Rayo Vallecano)", pos: "MF" },
            { n: "Pape Matar Sarr (Tottenham Hotspur)", pos: "MF", rare: "rare" },
            { n: "Bara Sapoko Ndiaye (Bayern Munich)", pos: "MF" },

            // Forwards
            { n: "Sadio Mané (Al Nassr)", pos: "FW", rare: "legendary" },
            { n: "Ismaïla Sarr (Crystal Palace)", pos: "FW", rare: "rare" },
            { n: "Iliman Ndiaye (Everton)", pos: "FW" },
            { n: "Assane Diao (Como)", pos: "FW" },
            { n: "Ibrahim Mbaye (Paris Saint-Germain)", pos: "FW" },
            { n: "Nicolas Jackson (Chelsea)", pos: "FW", rare: "rare" },
            { n: "Bamba Dieng (Lorient)", pos: "FW" },
            { n: "Cherif Ndiaye (Samsunspor)", pos: "FW" }
        ] },
    { id: "ALG", conf: "CAF", name: "Algeria", flag: f("D", "Z"), c1: "#006233", c2: "#D21034",
        players: [
            // Manager
            { n: "Vladimir Petkovic", pos: "HC", rare: "rare" },

            // Goalkeepers
            { n: "Oussama Benbot (USM Alger)", pos: "GK" },
            { n: "Melvin Masstil (Stade Nyonnaise)", pos: "GK" },
            { n: "Luca Zidane (Granada)", pos: "GK", rare: "rare" },

            // Defenders
            { n: "Achraf Abada (USM Alger)", pos: "DF" },
            { n: "Rayan Ait Nouri (Manchester City)", pos: "DF", rare: "rare" },
            { n: "Zinedine Belaid (JS Kabylie)", pos: "DF" },
            { n: "Rafik Belghali (Verona)", pos: "DF" },
            { n: "Ramy Bensebaini (Borussia Dortmund)", pos: "DF", rare: "rare" },
            { n: "Samir Chergui (Paris FC)", pos: "DF" },
            { n: "Jaouen Hadjam (Young Boys)", pos: "DF" },
            { n: "Aissa Mandi (Lille)", pos: "DF", rare: "rare" },
            { n: "Mohamed Amine Tougai (Esperance)", pos: "DF" },

            // Midfielders
            { n: "Houssem Aouar (Al Ittihad)", pos: "MF", rare: "rare" },
            { n: "Nabil Bentaleb (Lille)", pos: "MF" },
            { n: "Hicham Boudaoui (Nice)", pos: "MF" },
            { n: "Fares Chaibi (Eintracht Frankfurt)", pos: "MF" },
            { n: "Ibrahim Maza (Bayer Leverkusen)", pos: "MF" },
            { n: "Yassine Titraoui (Charleroi)", pos: "MF" },
            { n: "Ramiz Zerrouki (FC Twente)", pos: "MF" },

            // Forwards
            { n: "Mohamed Amine Amoura (VfL Wolfsburg)", pos: "FW", rare: "rare" },
            { n: "Nadir Benbouali (Győri ETO)", pos: "FW" },
            { n: "Adil Boulbina (Al Duhail)", pos: "FW" },
            { n: "Fares Ghedjemis (Frosinone)", pos: "FW" },
            { n: "Amine Gouiri (Marseille)", pos: "FW", rare: "rare" },
            { n: "Riyad Mahrez (Al Ahli)", pos: "FW", rare: "legendary" },
            { n: "Anis Hadj Moussa (Feyenoord)", pos: "FW" }
        ] },
    { id: "CPV", conf: "CAF", name: "Cabo Verde", flag: f("C", "V"), c1: "#003893", c2: "#CF2027",
        players: [
            // Manager
            { n: "Bubista", pos: "HC", rare: "rare" },

            // Goalkeepers
            { n: "Vozinha (Chaves)", pos: "GK", rare: "rare" },
            { n: "Marcio Rosa (Montana)", pos: "GK" },
            { n: "CJ dos Santos (San Diego FC)", pos: "GK" },

            // Defenders
            { n: "Steven Moreira (Columbus Crew)", pos: "DF" },
            { n: "Wagner Pina (Trabzonspor)", pos: "DF" },
            { n: "Joao Paulo (FCSB)", pos: "DF" },
            { n: "Sidny Lopes Cabral (Benfica)", pos: "DF" },
            { n: "Logan Costa (Villarreal)", pos: "DF", rare: "rare" },
            { n: "Pico (Shamrock Rovers)", pos: "DF" },
            { n: "Kelvin Pires (SJK)", pos: "DF" },
            { n: "Stopira (Torreense)", pos: "DF" },
            { n: "Diney (Al Bataeh)", pos: "DF" },

            // Midfielders
            { n: "Jamiro Monteiro (PEC Zwolle)", pos: "MF", rare: "rare" },
            { n: "Telmo Arcanjo (Vitoria Guimaraes)", pos: "MF" },
            { n: "Yannick Semedo (Farense)", pos: "MF" },
            { n: "Laros Duarte (Puskas Akademia)", pos: "MF" },
            { n: "Deroy Duarte (Ludogorets Razgrad)", pos: "MF" },
            { n: "Kevin Pina (Krasnodar)", pos: "MF", rare: "rare" },

            // Forwards
            { n: "Ryan Mendes (Igdir)", pos: "FW", rare: "legendary" },
            { n: "Willy Semedo (Omonia)", pos: "FW" },
            { n: "Garry Rodrigues (Apollon Limassol)", pos: "FW" },
            { n: "Jovane Cabral (Estrela Amadora)", pos: "FW", rare: "rare" },
            { n: "Nuno da Costa (Istanbul Basashehir)", pos: "FW" },
            { n: "Dailon Livramento (Casa Pia)", pos: "FW" },
            { n: "Gilson Benchimol (Akron Tolyatti)", pos: "FW" },
            { n: "Helio Varela (Maccabi Tel Aviv)", pos: "FW" }
        ] },
    { id: "COD", conf: "CAF", name: "DR Congo", flag: f("C", "D"), c1: "#007FFF", c2: "#CE1126",
        players: [
            // Manager
            { n: "Sebastien Desabre", pos: "HC", rare: "rare" },

            // Goalkeepers
            { n: "Lionel Mpasi (Le Havre)", pos: "GK", rare: "rare" },
            { n: "Timothy Fayulu (FC Noah)", pos: "GK" },
            { n: "Matthieu Epolo (Standard Liege)", pos: "GK" },

            // Defenders
            { n: "Chancel Mbemba (Lille)", pos: "DF", rare: "rare" },
            { n: "Axel Tuanzebe (Burnley)", pos: "DF" },
            { n: "Arthur Masuaku (Lens)", pos: "DF", rare: "rare" },
            { n: "Gédéon Kalulu (Aris Limassol)", pos: "DF" },
            { n: "Joris Kayembe (Genk)", pos: "DF" },
            { n: "Aaron Wan-Bissaka (West Ham United)", pos: "DF", rare: "rare" },
            { n: "Aaron Tshibola (Kilmarnock)", pos: "DF" },
            { n: "Steve Kapuadi (Widzew Łódź)", pos: "DF" },
            { n: "Dylan Batubinsika (AEL)", pos: "DF" },

            // Midfielders
            { n: "Noah Sadiki (Sunderland)", pos: "MF" },
            { n: "Charles Pickel (Espanyol)", pos: "MF" },
            { n: "Edo Kayembe (Watford)", pos: "MF" },
            { n: "Samuel Moutoussamy (Atromitos)", pos: "MF" },
            { n: "Ngal'ayel Mukau (Lille)", pos: "MF" },
            { n: "Nathanaël Mbuku (Montpellier)", pos: "MF" },
            { n: "Meschak Elia (Alanyaspor)", pos: "MF" },
            { n: "Brian Cipenga (Castellón)", pos: "MF" },
            { n: "Gaël Kakuta (AEL)", pos: "MF" },
            { n: "Théo Bongonda (Spartak Moscow)", pos: "MF" },

            // Forwards
            { n: "Simon Banza (Al Jazira)", pos: "FW", rare: "rare" },
            { n: "Yoane Wissa (Newcastle United)", pos: "FW", rare: "rare" },
            { n: "Fiston Mayele (Pyramids FC)", pos: "FW" },
            { n: "Cédric Bakambu (Real Betis)", pos: "FW", rare: "rare" }
        ] },
    { id: "CIV", conf: "CAF", name: "Côte d'Ivoire", flag: f("C", "I"), c1: "#FF8200", c2: "#009E60",
        players: [
            // Manager
            { n: "Emerse Faé", pos: "HC", rare: "rare" },

            // Goalkeepers
            { n: "Yahia Fofana (Rizespor)", pos: "GK", rare: "rare" },
            { n: "Mohamed Koné (Charleroi)", pos: "GK" },
            { n: "Alban Lafont (Panathinaikos)", pos: "GK", rare: "rare" },

            // Defenders
            { n: "Emmanuel Agbadou (Beşiktaş)", pos: "DF" },
            { n: "Clément Akpa (AJ Auxerre)", pos: "DF" },
            { n: "Ousmane Diomande (Sporting CP)", pos: "DF", rare: "rare" },
            { n: "Guela Doué (Strasbourg)", pos: "DF" },
            { n: "Ghislain Konan (Gil Vicente)", pos: "DF" },
            { n: "Odilon Kossounou (Atalanta)", pos: "DF", rare: "rare" },
            { n: "Evan Ndicka (AS Roma)", pos: "DF", rare: "rare" },
            { n: "Wilfried Singo (Galatasaray)", pos: "DF", rare: "rare" },

            // Midfielders
            { n: "Seko Fofana (Porto)", pos: "MF", rare: "rare" },
            { n: "Parfait Guiagon (Charleroi)", pos: "MF" },
            { n: "Franck Kessié (Al Ahli)", pos: "MF", rare: "legendary" },
            { n: "Christ Inao Oulaï (Trabzonspor)", pos: "MF" },
            { n: "Ibrahim Sangaré (Nottingham Forest)", pos: "MF", rare: "rare" },
            { n: "Jean Michaël Seri (NK Maribor)", pos: "MF" },

            // Forwards
            { n: "Simon Adingra (AS Monaco)", pos: "FW", rare: "rare" },
            { n: "Ange-Yoan Bonny (Internazionale)", pos: "FW", rare: "rare" },
            { n: "Amad Diallo (Manchester United)", pos: "FW", rare: "rare" },
            { n: "Oumar Diakité (Cercle Brugge)", pos: "FW" },
            { n: "Yan Diomande (RB Leipzig)", pos: "FW" },
            { n: "Evann Guessand (Aston Villa)", pos: "FW" },
            { n: "Nicolas Pépé (Villarreal)", pos: "FW", rare: "rare" },
            { n: "Bazoumana Touré (Hoffenheim)", pos: "FW" },
            { n: "Elye Wahi (Nice)", pos: "FW", rare: "rare" }
        ] },
    { id: "GHA", conf: "CAF", name: "Ghana", flag: f("G", "H"), c1: "#EF3340", c2: "#FFD200",
        players: [
            // Manager
            { n: "Carlos Queiroz", pos: "HC", rare: "rare" },

            // Goalkeepers
            { n: "Benjamin Asare (Accra Hearts of Oak SC)", pos: "GK" },
            { n: "Lawrence Ati-Zigi (St Gallen)", pos: "GK", rare: "rare" },
            { n: "Joseph Anang (St Patrick's Athletic)", pos: "GK" },
            { n: "Solomon Agbasi (Accra Hearts of Oak SC)", pos: "GK" },
            { n: "Paul Reverson (Ajax)", pos: "GK" },

            // Defenders
            { n: "Baba Abdul Rahman (PAOK)", pos: "DF" },
            { n: "Gideon Mensah (Auxerre)", pos: "DF" },
            { n: "Marvin Senaya (Auxerre)", pos: "DF" },
            { n: "Alidu Seidu (Rennes)", pos: "DF", rare: "rare" },
            { n: "Abdul Mumin (Rayo Vallecano)", pos: "DF" },
            { n: "Jerome Opoku (Istanbul Basaksehir)", pos: "DF" },
            { n: "Jonas Adjetey (Wolfsburg)", pos: "DF" },
            { n: "Kojo Oppong Peprah (Nice)", pos: "DF" },
            { n: "Alexander Djiku (Spartak Moscow)", pos: "DF", rare: "rare" },
            { n: "Elisha Owusu (Auxerre)", pos: "DF" },

            // Midfielders
            { n: "Thomas Partey (Villarreal)", pos: "MF", rare: "legendary" },
            { n: "Kwasi Sibo (Real Oviedo)", pos: "MF" },
            { n: "Augustine Boakye (Saint-Etienne)", pos: "MF" },
            { n: "Caleb Yirenkyi (Nordsjaelland)", pos: "MF" },
            { n: "Abdul Fatawu Issahaku (Leicester City)", pos: "MF", rare: "rare" },

            // Forwards
            { n: "Kamaldeen Sulemana (Atalanta)", pos: "FW", rare: "rare" },
            { n: "Christopher Bonsu Baah (Al Qadsiah)", pos: "FW" },
            { n: "Ernest Nuamah (Lyon)", pos: "FW", rare: "rare" },
            { n: "Antoine Semenyo (Manchester City)", pos: "FW", rare: "rare" },
            { n: "Brandon Thomas-Asante (Coventry City)", pos: "FW" },
            { n: "Prince Kwabena Adu (Viktoria Plzen)", pos: "FW" },
            { n: "Iñaki Williams (Athletic Bilbao)", pos: "FW", rare: "rare" },
            { n: "Jordan Ayew (Leicester City)", pos: "FW", rare: "rare" }
        ] },
    { id: "RSA", conf: "CAF", name: "South Africa", flag: f("Z", "A"), c1: "#007A4D", c2: "#FFB81C",
        players: [
            // Manager
            { n: "Hugo Broos", pos: "HC", rare: "rare" },

            // Goalkeepers
            { n: "Ronwen Williams (Mamelodi Sundowns)", pos: "GK", rare: "legendary" },
            { n: "Ricardo Goss (Mamelodi Sundowns)", pos: "GK" },
            { n: "Sipho Chaine (Orlando Pirates)", pos: "GK" },

            // Defenders
            { n: "Khuliso Mudau (Mamelodi Sundowns)", pos: "DF", rare: "rare" },
            { n: "Nkosinathi Sibisi (Orlando Pirates)", pos: "DF" },
            { n: "Ime Okon (Hannover 96)", pos: "DF" },
            { n: "Khulumani Ndamane (Mamelodi Sundowns)", pos: "DF" },
            { n: "Aubrey Modiba (Mamelodi Sundowns)", pos: "DF" },
            { n: "Samukelo Kabini (Molde)", pos: "DF" },
            { n: "Thabang Matuludi (Polokwane City)", pos: "DF" },
            { n: "Olwethu Makhanya (Philadelphia Union)", pos: "DF" },
            { n: "Kamgogelo Sebelebele (Orlando Pirates)", pos: "DF" },
            { n: "Bradley Cross (Kaizer Chiefs)", pos: "DF" },
            { n: "Mbekezeli Mbokazi (Chicago Fire)", pos: "DF" },

            // Midfielders
            { n: "Teboho Mokoena (Mamelodi Sundowns)", pos: "MF", rare: "rare" },
            { n: "Thalente Mbatha (Orlando Pirates)", pos: "MF" },
            { n: "Yaya Sithole (Tondela)", pos: "MF" },
            { n: "Jayden Adams (Mamelodi Sundowns)", pos: "MF" },

            // Forwards
            { n: "Oswin Appollis (Orlando Pirates)", pos: "FW" },
            { n: "Iqraam Rayners (Mamelodi Sundowns)", pos: "FW", rare: "rare" },
            { n: "Tshepang Moremi (Orlando Pirates)", pos: "FW" },
            { n: "Relebohile Mofokeng (Orlando Pirates)", pos: "FW", rare: "rare" },
            { n: "Evidence Makgopa (Orlando Pirates)", pos: "FW" },
            { n: "Themba Zwane (Mamelodi Sundowns)", pos: "FW", rare: "rare" },
            { n: "Lyle Foster (Burnley)", pos: "FW", rare: "legendary" },
            { n: "Thapelo Maseko (AEL Limassol)", pos: "FW" }
        ] },
    { id: "TUN", conf: "CAF", name: "Tunisia", flag: f("T", "N"), c1: "#E70013", c2: "#FFFFFF",
        players: [
            // Manager
            { n: "Sabri Lamouchi", pos: "HC", rare: "rare" },

            // Goalkeepers
            { n: "Aymen Dahmen (CS Sfaxien)", pos: "GK", rare: "rare" },
            { n: "Sabri Ben Hessen (Étoile du Sahel)", pos: "GK" },
            { n: "Abdelmouhib Chamakh (Club Africain)", pos: "GK" },

            // Defenders
            { n: "Montassar Talbi (Lorient)", pos: "DF", rare: "rare" },
            { n: "Dylan Bronn (Servette)", pos: "DF" },
            { n: "Omar Rekik (Maribor)", pos: "DF" },
            { n: "Yan Valery (Young Boys)", pos: "DF" },
            { n: "Ali Abdi (Nice)", pos: "DF", rare: "rare" },
            { n: "Moutaz Neffati (IFK Norrköping)", pos: "DF" },
            { n: "Raed Chikhaoui (US Monastir)", pos: "DF" },
            { n: "Adam Arous (Kasımpaşa)", pos: "DF" },
            { n: "Mohamed Amine Ben Hamida (Espérance de Tunis)", pos: "DF" },

            // Midfielders
            { n: "Ellyes Skhiri (Eintracht Frankfurt)", pos: "MF", rare: "legendary" },
            { n: "Hannibal Mejbri (Burnley)", pos: "MF", rare: "rare" },
            { n: "Anis Ben Slimane (Norwich City)", pos: "MF" },
            { n: "Hadj Mahmoud (Lugano)", pos: "MF" },
            { n: "Rani Khedira (Union Berlin)", pos: "MF", rare: "rare" },
            { n: "Mortadha Ben Ouanes (Kasımpaşa)", pos: "MF" },

            // Forwards
            { n: "Elias Achouri (Copenhagen)", pos: "FW", rare: "rare" },
            { n: "Ismaël Gharbi (Augsburg)", pos: "FW", rare: "rare" },
            { n: "Elias Saad (Hannover 96)", pos: "FW" },
            { n: "Sebastian Tounekti (Celtic)", pos: "FW" },
            { n: "Firas Chaouat (Club Africain)", pos: "FW" },
            { n: "Khalil Ayari (Paris Saint-Germain)", pos: "FW", rare: "rare" },
            { n: "Hazem Mastouri (Dynamo Makhachkala)", pos: "FW" },
            { n: "Rayan Elloumi (Vancouver Whitecaps)", pos: "FW" }
        ] },

    // AFC
    { id: "JPN", conf: "AFC", name: "Japan", flag: f("J", "P"), c1: "#BC002D", c2: "#FFFFFF",
        players: [
            // Manager
            { n: "Hajime Moriyasu", pos: "HC", rare: "rare" },

            // Goalkeepers
            { n: "Zion Suzuki (Parma)", pos: "GK", rare: "rare" },
            { n: "Keisuke Osako (Sanfrecce Hiroshima)", pos: "GK" },
            { n: "Tomoki Hayakawa (Kashima Antlers)", pos: "GK" },

            // Defenders
            { n: "Yūto Nagatomo (FC Tokyo)", pos: "DF" },
            { n: "Shogo Taniguchi (Sint-Truiden)", pos: "DF" },
            { n: "Ko Itakura (Ajax)", pos: "DF", rare: "rare" },
            { n: "Tsuyoshi Watanabe (Feyenoord)", pos: "DF" },
            { n: "Takehiro Tomiyasu (Ajax)", pos: "DF", rare: "legendary" },
            { n: "Hiroki Ito (Bayern Munich)", pos: "DF", rare: "rare" },
            { n: "Ayumu Seko (Le Havre)", pos: "DF" },
            { n: "Yukinari Sugawara (Werder Bremen)", pos: "DF", rare: "rare" },

            // Midfielders
            { n: "Junnosuke Suzuki (Copenhagen)", pos: "MF" },
            { n: "Wataru Endo (Liverpool)", pos: "MF", rare: "legendary" },
            { n: "Junya Ito (Genk)", pos: "MF", rare: "rare" },
            { n: "Daichi Kamada (Crystal Palace)", pos: "MF", rare: "rare" },
            { n: "Ritsu Doan (Eintracht Frankfurt)", pos: "MF", rare: "rare" },
            { n: "Ao Tanaka (Leeds United)", pos: "MF" },
            { n: "Keito Nakamura (Reims)", pos: "MF", rare: "rare" },
            { n: "Kaishu Sano (Mainz)", pos: "MF" },
            { n: "Takefusa Kubo (Real Sociedad)", pos: "MF", rare: "legendary" },
            { n: "Yuito Suzuki (Freiburg)", pos: "MF" },

            // Forwards
            { n: "Koki Ogawa (NEC Nijmegen)", pos: "FW" },
            { n: "Daizen Maeda (Celtic)", pos: "FW", rare: "rare" },
            { n: "Ayase Ueda (Feyenoord)", pos: "FW", rare: "rare" },
            { n: "Kento Shiogai (VfL Wolfsburg)", pos: "FW" },
            { n: "Keisuke Goto (Sint-Truiden)", pos: "FW" }
        ] },
    { id: "KOR", conf: "AFC", name: "South Korea", flag: f("K", "R"), c1: "#CE1126", c2: "#003478",
        players: [
            // Manager
            { n: "Hong Myung-Bo", pos: "HC", rare: "rare" },

            // Goalkeepers
            { n: "Jo Hyun-Woo (Ulsan HD)", pos: "GK", rare: "rare" },
            { n: "Kim Seung-Gyu (FC Tokyo)", pos: "GK" },
            { n: "Song Bum-Keun (Jeonbuk Hyundai)", pos: "GK" },

            // Defenders
            { n: "Kim Min-Jae (Bayern Munich)", pos: "DF", rare: "legendary" },
            { n: "Jo Yu-Min (Sharjah)", pos: "DF" },
            { n: "Lee Han-Beom (Midtjylland)", pos: "DF" },
            { n: "Kim Tae-Hyun (Kashima Antlers)", pos: "DF" },
            { n: "Park Jin-Seop (Zhejiang FC)", pos: "DF" },
            { n: "Lee Ki-Hyeok (Gangwon FC)", pos: "DF" },
            { n: "Lee Tae-Seok (Austria Vienna)", pos: "DF" },
            { n: "Seol Young-Woo (Red Star Belgrade)", pos: "DF", rare: "rare" },
            { n: "Jens Castrop (Borussia Mönchengladbach)", pos: "DF" },
            { n: "Kim Moon-Hwan (Daejeon Hana)", pos: "DF" },

            // Midfielders
            { n: "Yang Hyun-Jun (Celtic)", pos: "MF" },
            { n: "Paik Seung-Ho (Birmingham City)", pos: "MF" },
            { n: "Hwang In-Beom (Feyenoord)", pos: "MF", rare: "rare" },
            { n: "Kim Jin-Kyu (Jeonbuk Hyundai)", pos: "MF" },
            { n: "Bae Jun-Ho (Stoke City)", pos: "MF" },
            { n: "Um Ji-Sung (Swansea City)", pos: "MF" },
            { n: "Hwang Hee-Chan (Wolverhampton)", pos: "MF", rare: "rare" },
            { n: "Lee Dong-Gyeong (Ulsan HD)", pos: "MF" },
            { n: "Lee Jae-Sung (Mainz)", pos: "MF", rare: "rare" },
            { n: "Lee Kang-In (Paris Saint-Germain)", pos: "MF", rare: "rare" },

            // Forwards
            { n: "Oh Hyun-Kyu (Besiktas)", pos: "FW" },
            { n: "Son Heung-Min (LAFC)", pos: "FW", rare: "legendary" },
            { n: "Cho Kyu-Sung (Midtjylland)", pos: "FW" }
        ] },
    { id: "AUS", conf: "AFC", name: "Australia", flag: f("A", "U"), c1: "#00843D", c2: "#FFCD00",
        players: [
            // Manager
            { n: "Tony Popovic", pos: "HC", rare: "rare" },

            // Goalkeepers
            { n: "Mathew Ryan (Levante)", pos: "GK", rare: "rare" },
            { n: "Paul Izzo (Randers FC)", pos: "GK" },
            { n: "Patrick Beach (Melbourne City)", pos: "GK" },

            // Defenders
            { n: "Jordan Bos (Feyenoord Rotterdam)", pos: "DF" },
            { n: "Aziz Behich (Melbourne City)", pos: "DF" },
            { n: "Harry Souttar (Leicester City)", pos: "DF", rare: "rare" },
            { n: "Alessandro Circati (Parma)", pos: "DF" },
            { n: "Lucas Herrington (Colorado Rapids)", pos: "DF" },
            { n: "Cameron Burgess (Swansea City)", pos: "DF" },
            { n: "Kai Trewin (New York City FC)", pos: "DF" },
            { n: "Milos Degenek (Apoel Nicosia)", pos: "DF" },
            { n: "Jason Geria (Albirex Niigata)", pos: "DF" },
            { n: "Jacob Italiano (Grazer AK)", pos: "DF" },

            // Midfielders
            { n: "Jackson Irvine (St. Pauli)", pos: "MF", rare: "rare" },
            { n: "Aiden O'Neill (New York City FC)", pos: "MF" },
            { n: "Paul Okon Jr (Sydney FC)", pos: "MF" },
            { n: "Cameron Devlin (Heart of Midlothian)", pos: "MF" },

            // Forwards
            { n: "Connor Metcalfe (St. Pauli)", pos: "FW" },
            { n: "Mathew Leckie (Melbourne City)", pos: "FW" },
            { n: "Nishan Velupillay (Melbourne Victory)", pos: "FW" },
            { n: "Cristian Volpato (Sassuolo)", pos: "FW" },
            { n: "Nestory Irankunda (Watford)", pos: "FW", rare: "legendary" },
            { n: "Awer Mabil (Castellón)", pos: "FW" },
            { n: "Ajdin Hrustic (Heracles Almelo)", pos: "FW" },
            { n: "Mohamed Toure (Norwich City)", pos: "FW" },
            { n: "Tete Yengi (Machida Zelvia)", pos: "FW" }
        ] },
    { id: "IRQ", conf: "AFC", name: "Iraq", flag: f("I", "Q"), c1: "#007A3D", c2: "#CE1126",
        players: [
            // Manager
            { n: "Graham Arnold", pos: "HC", rare: "rare" },

            // Goalkeepers
            { n: "Fahad Talib (Al-Talaba)", pos: "GK" },
            { n: "Jalal Hassan (Al-Zawraa)", pos: "GK", rare: "rare" },
            { n: "Ahmed Basil (Al-Shorta)", pos: "GK" },

            // Defenders
            { n: "Hussein Ali (Pogoń Szczecin)", pos: "DF", rare: "rare" },
            { n: "Manaf Younis (Al-Shorta)", pos: "DF" },
            { n: "Zaid Tahseen (Pakhtakor)", pos: "DF" },
            { n: "Rebin Sulaka (Port FC)", pos: "DF" },
            { n: "Akam Hashem (Al-Zawraa)", pos: "DF" },
            { n: "Merchas Doski (Viktoria Plzeň)", pos: "DF" },
            { n: "Ahmed Yahya (Al-Shorta)", pos: "DF" },
            { n: "Zaid Ismail (Al-Talaba)", pos: "DF" },
            { n: "Frans Putros (Port FC)", pos: "DF" },
            { n: "Mustafa Saadoon (Al-Shorta)", pos: "DF" },

            // Midfielders
            { n: "Amir Al-Ammari (Cracovia)", pos: "MF" },
            { n: "Kevin Yakob (AGF Aarhus)", pos: "MF" },
            { n: "Zidane Iqbal (FC Utrecht)", pos: "MF", rare: "legendary" },
            { n: "Aimar Sher (Sarpsborg 08)", pos: "MF" },
            { n: "Ibrahim Bayesh (Al-Riyadh)", pos: "MF", rare: "rare" },
            { n: "Ahmed Qasim (Elfsborg)", pos: "MF" },
            { n: "Youssef Amyn (Eintracht Braunschweig)", pos: "MF" },
            { n: "Marko Farji (Strømsgodset)", pos: "MF" },

            // Forwards
            { n: "Ali Jasim (Como)", pos: "FW", rare: "rare" },
            { n: "Ali Al-Hamadi (Ipswich Town)", pos: "FW", rare: "rare" },
            { n: "Ali Yousef (Al-Shorta)", pos: "FW" },
            { n: "Aymen Hussein (Al-Khor)", pos: "FW", rare: "rare" },
            { n: "Mohanad Ali (Al-Shorta)", pos: "FW", rare: "rare" }
        ] },
    { id: "IRN", conf: "AFC", name: "Iran", flag: f("I", "R"), c1: "#239F40", c2: "#DA0000",
        players: [
            // Manager
            { n: "Amir Ghalenoei", pos: "HC", rare: "rare" },

            // Goalkeepers
            { n: "Alireza Beiranvand (Tractor)", pos: "GK", rare: "rare" },
            { n: "Hossein Hosseini (Sepahan)", pos: "GK" },
            { n: "Payam Niazmand (Persepolis)", pos: "GK" },
            { n: "Mohammed Khalifeh (Aluminium Arak)", pos: "GK" },

            // Defenders
            { n: "Danial Eiri (Malavan)", pos: "DF" },
            { n: "Ehsan Hajsafi (Sepahan)", pos: "DF", rare: "rare" },
            { n: "Saleh Hardani (Esteghlal)", pos: "DF" },
            { n: "Hossein Kanaani (Persepolis)", pos: "DF" },
            { n: "Shoka Khalilzadeh (Tractor)", pos: "DF" },
            { n: "Milad Mohammadi (Persepolis)", pos: "DF", rare: "rare" },
            { n: "Ali Nemati (Foolad)", pos: "DF" },
            { n: "Omid Noorafkan (Foolad)", pos: "DF" },
            { n: "Ramin Rezaeian (Foolad)", pos: "DF", rare: "rare" },

            // Midfielders
            { n: "Rouzbeh Cheshmi (Esteghlal)", pos: "MF" },
            { n: "Saeid Ezatolahi (Shabab Al-Ahli)", pos: "MF" },
            { n: "Mehdi Ghaedi (Al-Nasr)", pos: "MF", rare: "rare" },
            { n: "Saman Ghoddos (Kalba)", pos: "MF", rare: "rare" },
            { n: "Mohammad Ghorbani (Al-Wahda)", pos: "MF" },
            { n: "Alireza Jahanbakhsh (Dender)", pos: "MF", rare: "rare" },
            { n: "Mohammad Mohebi (Rostovv)", pos: "MF" },
            { n: "Amir Mohammad Razzaghinia (Esteghlal)", pos: "MF" },
            { n: "Mehdi Torabi (Tractor)", pos: "MF" },
            { n: "Aria Yousefi (Sepahan)", pos: "MF" },

            // Forwards
            { n: "Ali Alipour (Persepolis)", pos: "FW" },
            { n: "Dennis Dargahi (Standard Liege)", pos: "FW" },
            { n: "Hadi Habibinejad (Chadormalou)", pos: "FW" },
            { n: "Amirhossein Hosseinzadeh (Tractor)", pos: "FW" },
            { n: "Amirhossein Mahmoudi (Persepolis)", pos: "FW" },
            { n: "Kasra Taheri (Paykan)", pos: "FW" },
            { n: "Mehdi Taremi (Olympiacos)", pos: "FW", rare: "legendary" }
        ] },
    { id: "JOR", conf: "AFC", name: "Jordan", flag: f("J", "O"), c1: "#000000", c2: "#CE1126",
        players: [
            // Manager
            { n: "Jamal Sellami", pos: "HC", rare: "rare" },

            // Goalkeepers
            { n: "Yazid Abulaila (Al-Hussein)", pos: "GK", rare: "rare" },
            { n: "Abdallah Al-Fakhouri (Al-Wehdat)", pos: "GK" },
            { n: "Ahmad Al-Juiadi (Shabab Al-Ordon)", pos: "GK" },
            { n: "Nour Bani Attiah (Al-Faisaly)", pos: "GK" },

            // Defenders
            { n: "Mohammad Abualnadi (Selangor)", pos: "DF" },
            { n: "Yousef Abu Al-Jazar (Al-Hussein)", pos: "DF" },
            { n: "Husam Abu Dahab (Al-Faisaly)", pos: "DF" },
            { n: "Mohammed Abu Hashish (Al-Karma)", pos: "DF" },
            { n: "Mohannad Abu Taha (Al-Quwa Al-Jawiya)", pos: "DF" },
            { n: "Yazan Al-Arab (FC Seoul)", pos: "DF", rare: "rare" },
            { n: "Saed Al-Rosna (Al-Hussein)", pos: "DF" },
            { n: "Ahmad Assaf (Al-Hussein)", pos: "DF" },
            { n: "Anas Badawi (Al-Faisaly)", pos: "DF" },
            { n: "Abdallah Nasib (Al-Zawraa)", pos: "DF", rare: "rare" },
            { n: "Ehsan Haddad (Al-Hussein)", pos: "DF", rare: "rare" },
            { n: "Saleem Obaid (Al-Hussein)", pos: "DF" },
            { n: "Mohammad Abu Taha (Al-Quwa Al-Jawiya)", pos: "DF" },

            // Midfielders
            { n: "Mohammed Al-Dawoud (Al-Wehdat)", pos: "MF" },
            { n: "Nizar Al-Rashdan (Qatar SC)", pos: "MF" },
            { n: "Noor Al-Rawabdeh (Selangor)", pos: "MF", rare: "rare" },
            { n: "Rajaei Ayed (Al-Hussein)", pos: "MF" },
            { n: "Amer Jamous (Al-Zawraa)", pos: "MF" },
            { n: "Yousef Qashi (Al-Hussein)", pos: "MF" },
            { n: "Ibrahim Sadeh (Al-Karma)", pos: "MF" },

            // Forwards
            { n: "Mohammed Abu Zraiq (Raja Casablanca)", pos: "FW" },
            { n: "Mousa Al-Tamari (Rennes)", pos: "FW", rare: "legendary" },
            { n: "Ali Azaizeh (Al-Shabab)", pos: "FW" },
            { n: "Odeh Al-Fakhouri (Pyramids)", pos: "FW" },
            { n: "Ali Olwan (Al-Sailiaya)", pos: "FW", rare: "rare" },
            { n: "Ibrahim Sabra (Lokomotiva Zagreb)", pos: "FW" }
        ] },
    { id: "QAT", conf: "AFC", name: "Qatar", flag: f("Q", "A"), c1: "#8D153A", c2: "#FFFFFF",
        players: [
            // Goalkeepers
            { n: "Shehab Elleithy (Al Shahania)", pos: "GK" },
            { n: "Salah Zakaria (Al Duhail)", pos: "GK" },
            { n: "Meshaal Barsham (Al Sadd)", pos: "GK", rare: "rare" },
            { n: "Mahmoud Abunada (Al Rayyan)", pos: "GK" },

            // Defenders
            { n: "Boualem Khoukhi (Al Sadd)", pos: "DF", rare: "rare" },
            { n: "Pedro Miguel (Al Sadd)", pos: "DF" },
            { n: "Sultan Al Brake (Al Duhail)", pos: "DF" },
            { n: "Tarek Salman (Al Sadd)", pos: "DF" },
            { n: "Al-Hashmi Al-Hussain (Al Arabi)", pos: "DF" },
            { n: "Ayoub Al-Alawi (Al Gharafa)", pos: "DF" },
            { n: "Bassam Al-Rawi (Al Duhail)", pos: "DF" },
            { n: "Rayyan Al-Ali (Al Gharafa)", pos: "DF" },
            { n: "Issa Laye (Al Arabi)", pos: "DF" },
            { n: "Lucas Mendes (Al Wakrah)", pos: "DF", rare: "rare" },
            { n: "Mohammed Waad (Al Shamal)", pos: "DF" },
            { n: "Niall Mason (Qatar)", pos: "DF" },

            // Midfielders
            { n: "Ahmed Fathi (Al Arabi)", pos: "MF" },
            { n: "Jassim Gaber (Al Rayyan)", pos: "MF" },
            { n: "Assim Madibo (Al Wakrah)", pos: "MF" },
            { n: "Abdulaziz Hatem (Al Rayyan)", pos: "MF" },
            { n: "Karim Boudiaf (Al Duhail)", pos: "MF" },
            { n: "Mohammed Mannai (Al Shamal)", pos: "MF" },
            { n: "Homam Al-Amin (Cultural Leonesa)", pos: "MF" },

            // Forwards
            { n: "Almoez Ali (Al Duhail)", pos: "FW", rare: "rare" },
            { n: "Akram Afif (Al Sadd)", pos: "FW", rare: "legendary" },
            { n: "Tahsin Mohammed (Al Duhail)", pos: "FW" },
            { n: "Edmílson Junior (Al Duhail)", pos: "FW", rare: "rare" },
            { n: "Ahmed Al-Ganehi (Al Gharafa)", pos: "FW" },
            { n: "Ahmed Alaa (Al Rayyan)", pos: "FW" },
            { n: "Sebastián Soria (Qatar)", pos: "FW" },
            { n: "Hassan Al-Haydos (Al Sadd)", pos: "FW", rare: "rare" },
            { n: "Mubarak Shannan (Al Duhail)", pos: "FW" },
            { n: "Mohammed Muntari (Al Gharafa)", pos: "FW" },
            { n: "Yusuf Abdurisag (Al Wakrah)", pos: "FW" }
        ] },
    { id: "KSA", conf: "AFC", name: "Saudi Arabia", flag: f("S", "A"), c1: "#006C35", c2: "#FFFFFF",
        players: [
            // Manager
            { n: "Georgios Donis", pos: "HC", rare: "rare" },

            // Goalkeepers
            { n: "Mohammed Al Owais (Al Ula)", pos: "GK", rare: "rare" },
            { n: "Nawaf Al Aqidi (Al Nassr)", pos: "GK" },
            { n: "Ahmed Al Kassar (Al Qadsiah)", pos: "GK" },

            // Defenders
            { n: "Abdulelah Al Amri (Al Nassr)", pos: "DF" },
            { n: "Hassan Tambakti (Al Hilal)", pos: "DF", rare: "rare" },
            { n: "Jehad Thikri (Al Qadsiah)", pos: "DF" },
            { n: "Ali Lajami (Al Hilal)", pos: "DF" },
            { n: "Hassan Kadesh (Al Ittihad)", pos: "DF" },
            { n: "Saud Abdulhamid (Lens)", pos: "DF", rare: "rare" },
            { n: "Mohammed Abu Al Shamat (Al Qadsiah)", pos: "DF" },
            { n: "Ali Majrashi (Al Ahli)", pos: "DF" },
            { n: "Moteb Al Harbi (Al Hilal)", pos: "DF" },
            { n: "Nawaf Boushal (Al Nassr)", pos: "DF" },
            { n: "Sultan Al-Ghannam (Al Nassr)", pos: "DF" },

            // Midfielders
            { n: "Mohammed Kanno (Al Hilal)", pos: "MF", rare: "rare" },
            { n: "Abdullah Al Khaibari (Al Nassr)", pos: "MF" },
            { n: "Ziyad Al Johani (Al Ahli)", pos: "MF" },
            { n: "Nasser Al Dawsari (Al Hilal)", pos: "MF" },
            { n: "Musab Al Juwayr (Al Qadsiah)", pos: "MF" },
            { n: "Alaa Al Hajji (Neom)", pos: "MF" },
            { n: "Salem Al Dawsari (Al Hilal)", pos: "MF", rare: "legendary" },
            { n: "Khalid Al Ghannam (Al Ettifaq)", pos: "MF" },
            { n: "Ayman Yahya (Al Nassr)", pos: "MF" },

            // Forwards
            { n: "Firas Al Buraikan (Al Ahli)", pos: "FW", rare: "rare" },
            { n: "Saleh Al Shehri (Al Ittihad)", pos: "FW" },
            { n: "Abdullah Al Hamdan (Al Nassr)", pos: "FW" }
        ] },
    { id: "UZB", conf: "AFC", name: "Uzbekistan", flag: f("U", "Z"), c1: "#0099B5", c2: "#FFFFFF",
        players: [
            // Manager
            { n: "Fabio Cannavaro", pos: "HC", rare: "rare" },

            // Goalkeepers
            { n: "Vladimir Nazarov (Pakhtakor)", pos: "GK" },
            { n: "Utkir Yusupov (Navbahor)", pos: "GK", rare: "rare" },
            { n: "Botirali Ergashev (AGMK)", pos: "GK" },
            { n: "Abduvokhid Nematov (Nasaf)", pos: "GK" },

            // Defenders
            { n: "Ibrohimkhalil Yuldoshev (Neftchi)", pos: "DF" },
            { n: "Avazbek Ulmasaliev (AGMK)", pos: "DF" },
            { n: "Jakhongir Urozov (Dinamo Samarqand)", pos: "DF" },
            { n: "Rustamjon Ashurmatov (Esteghlal)", pos: "DF" },
            { n: "Mukhammadkodir Hamraliev (Pakhtakor)", pos: "DF" },
            { n: "Umarbek Eshmurodov (Nasaf)", pos: "DF" },
            { n: "Abdukodir Khusanov (Manchester City)", pos: "DF", rare: "rare" },
            { n: "Abdulla Abdullaev (Dibba Al Fujairah)", pos: "DF" },
            { n: "Farrukh Sayfiev (Neftchi)", pos: "DF" },
            { n: "Khojiakbar Alijonov (Pakhtakor)", pos: "DF" },
            { n: "Sherzod Nasrullaev (Nasaf)", pos: "DF" },
            { n: "Muhammadrasul Abdumajidov (Pakhtakor)", pos: "DF" },
            { n: "Behruz Karimov (Surkhon)", pos: "DF" },
            { n: "Diyor Ortikboev (Khorazm)", pos: "DF" },

            // Midfielders
            { n: "Kuvondik Ruziev (Neftchi)", pos: "MF" },
            { n: "Sherzod Esanov (Buxoro)", pos: "MF" },
            { n: "Nodirbek Abdurazzokov (AGMK)", pos: "MF" },
            { n: "Odiljon Khamrobekov (Tractor)", pos: "MF" },
            { n: "Umarali Rakhmonaliev (Sabah)", pos: "MF" },
            { n: "Alisher Odilov (Neftchi)", pos: "MF" },
            { n: "Sardorbek Rakhmonov (Nasaf)", pos: "MF" },
            { n: "Akmal Mozgovoy (Pakhtakor)", pos: "MF" },
            { n: "Otabek Shukurov (Baniyas)", pos: "MF", rare: "rare" },
            { n: "Jamshid Iskanderov (Neftchi)", pos: "MF" },
            { n: "Jasurbek Jaloliddinov (Sogdiana)", pos: "MF" },
            { n: "Azizjon Ganiev (Al Bataeh)", pos: "MF" },

            // Forwards
            { n: "Abbosek Fayzullaev (Istanbul Basaksehir)", pos: "FW", rare: "rare" },
            { n: "Jaloliddin Masharipov (Esteghlal)", pos: "FW", rare: "rare" },
            { n: "Dostonbek Khamdamov (Pakhtakor)", pos: "FW" },
            { n: "Oston Urunov (Persepolis)", pos: "FW", rare: "rare" },
            { n: "Ruslanbek Jiyanov (Navbahor)", pos: "FW" },
            { n: "Azizbek Amonov (Buxoro)", pos: "FW" },
            { n: "Khusain Norchaev (Navbahor)", pos: "FW" },
            { n: "Sherzod Temirov (Erbil)", pos: "FW" },
            { n: "Igor Sergeev (Persepolis)", pos: "FW" },
            { n: "Eldor Shomurodov (Istanbul Basaksehir)", pos: "FW", rare: "legendary" }
        ] },
    { id: "CUW", conf: "CONCACAF", name: "Curaçao", flag: f("C", "W"), c1: "#002B7F", c2: "#F9D21C",
        players: [
            // Manager
            { n: "Dick Advocaat", pos: "HC", rare: "rare" },

            // Goalkeepers
            { n: "Eloy Room (Miami FC)", pos: "GK", rare: "rare" },
            { n: "Tyrick Bodak (Telstar)", pos: "GK" },
            { n: "Trevor Doornbusch (VVV Venlo)", pos: "GK" },

            // Defenders
            { n: "Riechedly Bazoer (Konyaspor)", pos: "DF", rare: "rare" },
            { n: "Joshua Brenet (Kayserispor)", pos: "DF" },
            { n: "Roshon van Eijma (RKC Waalwijk)", pos: "DF" },
            { n: "Sherel Floranus (PEC Zwolle)", pos: "DF" },
            { n: "Deveron Fonville (NEC Nijmegen)", pos: "DF" },
            { n: "Jurien Gaari (Abha)", pos: "DF" },
            { n: "Armando Obispo (PSV Eindhoven)", pos: "DF", rare: "rare" },
            { n: "Shurandy Sambo (Sparta Rotterdam)", pos: "DF" },

            // Midfielders
            { n: "Juninho Bacuna (Volendam)", pos: "MF", rare: "rare" },
            { n: "Leandro Bacuna (Igdir)", pos: "MF", rare: "rare" },
            { n: "Livano Comenencia (Zurich)", pos: "MF" },
            { n: "Kevin Felida (Den Bosch)", pos: "MF" },
            { n: "Ar'jany Martha (Rotherham United)", pos: "MF" },
            { n: "Tyrese Noslin (Telstar)", pos: "MF" },
            { n: "Godfried Roemeratoe (RKC Waalwijk)", pos: "MF" },

            // Forwards
            { n: "Jeremy Antonisse (Kifisia)", pos: "FW" },
            { n: "Tahith Chong (Sheffield United)", pos: "FW", rare: "legendary" },
            { n: "Kenji Gorre (Maccabi Haifa)", pos: "FW" },
            { n: "Sontje Hansen (Middlesbrough)", pos: "FW" },
            { n: "Gervane Kastaneer (Terengganu)", pos: "FW" },
            { n: "Brandley Kuwas (Volendam)", pos: "FW" },
            { n: "Jurgen Locadia (Miami FC)", pos: "FW" },
            { n: "Jearl Margaritha (Beveren)", pos: "FW" }
        ] },
    { id: "HAI", conf: "CONCACAF", name: "Haiti", flag: f("H", "T"), c1: "#00209F", c2: "#D21034",
        players: [
            // Manager
            { n: "Sebastien Migne", pos: "HC", rare: "rare" },

            // Goalkeepers
            { n: "Johny Placide (Bastia)", pos: "GK", rare: "rare" },
            { n: "Alexandre Pierre (Sochaux)", pos: "GK" },
            { n: "Josue Duverger (Cosmos Koblenz)", pos: "GK" },

            // Defenders
            { n: "Carlens Arcus (Angers)", pos: "DF" },
            { n: "Wilguens Paugain (Zulte Waregem)", pos: "DF" },
            { n: "Duke Lacroix (Colorado Springs)", pos: "DF" },
            { n: "Martin Expérience (Nancy)", pos: "DF" },
            { n: "Jean-Kévin Duverne (Gent)", pos: "DF", rare: "rare" },
            { n: "Ricardo Adé (LDU Quito)", pos: "DF", rare: "rare" },
            { n: "Hannes Delcroix (Lugano)", pos: "DF" },
            { n: "Keeto Thermoncy (Young Boys)", pos: "DF" },

            // Midfielders
            { n: "Carl Fred Sainté (El Paso Locomotive)", pos: "MF" },
            { n: "Leverton Pierre (Vizela)", pos: "MF" },
            { n: "Danley Jean Jacques (Philadelphia Union)", pos: "MF", rare: "rare" },
            { n: "Jean-Ricner Bellegarde (Wolverhampton Wanderers)", pos: "MF", rare: "legendary" },
            { n: "Woodensky Pierre (Violette)", pos: "MF" },
            { n: "Dominique Simon (FC Tatran Prešov)", pos: "MF" },

            // Forwards
            { n: "Don Deedson Louicius (FC Dallas)", pos: "FW" },
            { n: "Josué Casimir (Auxerre)", pos: "FW" },
            { n: "Derrick Etienne (Toronto FC)", pos: "FW" },
            { n: "Ruben Providence (Almere)", pos: "FW" },
            { n: "Duckens Nazon (Esteghlal)", pos: "FW", rare: "rare" },
            { n: "Frantzdy Pierrot (Çaykur Rizespor)", pos: "FW", rare: "rare" },
            { n: "Wilson Isidor (Sunderland)", pos: "FW", rare: "rare" },
            { n: "Yassin Fortuné (Vizela)", pos: "FW" },
            { n: "Lenny Joseph (Ferencváros)", pos: "FW" }
        ] },
    { id: "PAN", conf: "CONCACAF", name: "Panama", flag: f("P", "A"), c1: "#DA121A", c2: "#072357",
        players: [{ n: "A. Carrasquilla", pos: "MF", rare: "rare" }, { n: "M. Murillo", pos: "DF", rare: "rare" }, { n: "F. Baloy", pos: "DF" }] },
    { id: "NZL", conf: "OFC", name: "New Zealand", flag: f("N", "Z"), c1: "#000000", c2: "#FFFFFF",
        players: [
            // Manager
            { n: "Darren Bazeley", pos: "HC", rare: "rare" },

            // Goalkeepers
            { n: "Max Crocombe (Millwall)", pos: "GK", rare: "rare" },
            { n: "Alex Paulsen (Lechia Gdańsk)", pos: "GK" },
            { n: "Michael Woud (Auckland FC)", pos: "GK" },

            // Defenders
            { n: "Tim Payne (Wellington Phoenix)", pos: "DF" },
            { n: "Francis De Vries (Auckland FC)", pos: "DF" },
            { n: "Tyler Bindon (Nottingham Forest)", pos: "DF" },
            { n: "Michael Boxall (Minnesota United)", pos: "DF" },
            { n: "Liberato Cacace (Wrexham)", pos: "DF", rare: "rare" },
            { n: "Nando Pijnaker (Auckland FC)", pos: "DF" },
            { n: "Finn Surman (Portland Timbers)", pos: "DF" },
            { n: "Callan Elliot (Auckland FC)", pos: "DF" },
            { n: "Tommy Smith (Braintree Town)", pos: "DF" },

            // Midfielders
            { n: "Joe Bell (Viking FK)", pos: "MF", rare: "rare" },
            { n: "Matt Garbett (Peterborough United)", pos: "MF" },
            { n: "Marko Stamenic (Swansea City)", pos: "MF", rare: "rare" },
            { n: "Sarpreet Singh (Wellington Phoenix)", pos: "MF", rare: "rare" },
            { n: "Alex Rufer (Wellington Phoenix)", pos: "MF" },
            { n: "Ryan Thomas (PEC Zwolle)", pos: "MF" },

            // Forwards
            { n: "Chris Wood (Nottingham Forest)", pos: "FW", rare: "legendary" },
            { n: "Eli Just (Motherwell)", pos: "FW" },
            { n: "Kosta Barbarouses (Western Sydney Wanderers)", pos: "FW" },
            { n: "Ben Waine (Port Vale)", pos: "FW" },
            { n: "Ben Old (Saint-Étienne)", pos: "FW", rare: "rare" },
            { n: "Callum McCowatt (Silkeborg IF)", pos: "FW" },
            { n: "Jesse Randall (Auckland FC)", pos: "FW" },
            { n: "Lachlan Bayliss (Newcastle Jets)", pos: "FW" }
        ] },
];

export const CONF_META: Record<Confederation, ConfMeta> = {
    HOST: { label: "Host Nations", color: "#FFD700" },
    UEFA: { label: "UEFA — Europe", color: "#003DA5" },
    CONMEBOL: { label: "CONMEBOL — South America", color: "#007A3D" },
    CAF: { label: "CAF — Africa", color: "#C1272D" },
    AFC: { label: "AFC — Asia", color: "#8D153A" },
    CONCACAF: { label: "CONCACAF — North & Central America", color: "#DA121A" },
    OFC: { label: "OFC — Oceania", color: "#1EB53A" },
};

export const CONF_ORDER: Confederation[] = ["HOST", "UEFA", "CONMEBOL", "CAF", "AFC", "CONCACAF", "OFC"];

export const SPECIALS = [
    { id: "SP1", name: "World Cup Trophy", icon: "🏆", rarity: "legendary" },
    { id: "SP2", name: "Official Ball", icon: "⚽", rarity: "rare" },
    { id: "SP3", name: "FIFA 2026 Logo", icon: "🌐", rarity: "common" },
    { id: "SP4", name: "MetLife Stadium (NY/NJ 🇺🇸)", icon: "🏟️", rarity: "rare" },
    { id: "SP5", name: "Estadio Azteca (Mexico City 🇲🇽)", icon: "🏟️", rarity: "legendary" },
    { id: "SP6", name: "BMO Field (Toronto 🇨🇦)", icon: "🏟️", rarity: "rare" },
    { id: "SP7", name: "Golden Boot", icon: "👟", rarity: "legendary" },
    { id: "SP8", name: "Golden Glove", icon: "🧤", rarity: "legendary" },
    { id: "SP9", name: "BC Place (Vancouver 🇨🇦)", icon: "🏟️", rarity: "rare" },
    { id: "SP10", name: "Estadio Akron (Guadalajara 🇲🇽)", icon: "🏟️", rarity: "common" },
    { id: "SP11", name: "Estadio BBVA (Monterrey 🇲🇽)", icon: "🏟️", rarity: "common" },
    { id: "SP12", name: "Mercedes-Benz Stadium (Atlanta 🇺🇸)", icon: "🏟️", rarity: "rare" },
    { id: "SP13", name: "Gillette Stadium (Boston 🇺🇸)", icon: "🏟️", rarity: "common" },
    { id: "SP14", name: "AT&T Stadium (Dallas 🇺🇸)", icon: "🏟️", rarity: "legendary" },
] as const;

export const buildAllStickers = (): Sticker[] => {
    let n = 1;
    const all: Sticker[] = [];
    SPECIALS.forEach(s => all.push({ ...s, type: "special", num: n++, rarity: s.rarity as any }));
    TEAMS.forEach(t => {
        all.push({ id: `${t.id}_B`, type: "badge", teamId: t.id, name: `${t.name} Crest`, rarity: "common", num: n++ });
        t.players.forEach((p, i) => all.push({
            id: `${t.id}_P${i}`, type: "player", teamId: t.id, name: p.n, pos: p.pos,
            rarity: p.rare || "common", num: n++
        }));
    });
    return all;
};

export const ALL_STICKERS = buildAllStickers();
export const STICKER_MAP = Object.fromEntries(ALL_STICKERS.map(s => [s.id, s]));

export const POS_ICON: Record<string, string> = { FW: "⚡", MF: "🔄", DF: "🛡️", GK: "🧤", HC: "👔" };
export const POS_CLR: Record<string, string> = { FW: "#e74c3c", MF: "#3498db", DF: "#27ae60", GK: "#e67e22", HC: "#9b59b6" };

export interface AchievementDefinition {
    id: string;
    title: string;
    description: string;
    rewardPacks: number;
    icon: string;
    conditionDescription: string;
}

export const ACHIEVEMENTS: AchievementDefinition[] = [
    {
        id: "first_pack",
        title: "First Unboxing",
        description: "Open your very first sticker pack and begin your journey!",
        conditionDescription: "Open 1 pack",
        rewardPacks: 1,
        icon: "📦"
    },
    {
        id: "lucky_draw",
        title: "Holographic Gold",
        description: "Unravel a legendary sticker from any pack.",
        conditionDescription: "Obtain a legendary sticker",
        rewardPacks: 2,
        icon: "✨"
    },
    {
        id: "double_trouble",
        title: "Double Trouble",
        description: "Receive your first duplicate sticker.",
        conditionDescription: "Obtain a duplicate sticker",
        rewardPacks: 1,
        icon: "👯"
    },
    {
        id: "novice_scout",
        title: "Novice Scout",
        description: "Reach 10% progress in your Paganini album.",
        conditionDescription: "Own 10% of total stickers",
        rewardPacks: 2,
        icon: "🔍"
    },
    {
        id: "pro_collector",
        title: "Pro Collector",
        description: "Reach 35% progress in your Paganini album.",
        conditionDescription: "Own 35% of total stickers",
        rewardPacks: 3,
        icon: "🏆"
    },
    {
        id: "elite_curator",
        title: "Elite Curator",
        description: "Reach 70% progress in your Paganini album.",
        conditionDescription: "Own 70% of total stickers",
        rewardPacks: 5,
        icon: "🌟"
    },
    {
        id: "active_streak_3",
        title: "Consistent Collector",
        description: "Log in 3 days in a row.",
        conditionDescription: "Active streak of 3 days",
        rewardPacks: 2,
        icon: "🔥"
    },
    {
        id: "profile_pioneer",
        title: "Profile Pioneer",
        description: "Customize your collector nickname or choose a World Cup 2026 avatar.",
        conditionDescription: "Change username or mascot avatar",
        rewardPacks: 1,
        icon: "🎨"
    },
    {
        id: "beacon_active",
        title: "Community Beacon",
        description: "Activate your discovery status to connect with other players.",
        conditionDescription: "Toggle 'I Want to Connect'",
        rewardPacks: 1,
        icon: "📡"
    }
];
